var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 102,
    viewBox: "0 0 284 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-557 7.62939e-06L-556.134 0.500008L-559.134 5.69616L-560 5.19616L-557 7.62939e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 0L-548.134 0.5L-551.134 5.69615L-552 5.19615L-549 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 0L-540.134 0.5L-543.134 5.69615L-544 5.19615L-541 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 0L-532.134 0.5L-535.134 5.69615L-536 5.19615L-533 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 0L-524.134 0.5L-527.134 5.69615L-528 5.19615L-525 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 0L-516.134 0.5L-519.134 5.69615L-520 5.19615L-517 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 0L-508.134 0.5L-511.134 5.69615L-512 5.19615L-509 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 0L-500.134 0.5L-503.134 5.69615L-504 5.19615L-501 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 0L-492.134 0.5L-495.134 5.69615L-496 5.19615L-493 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 0L-484.134 0.5L-487.134 5.69615L-488 5.19615L-485 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 0L-476.134 0.5L-479.134 5.69615L-480 5.19615L-477 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 0L-468.134 0.5L-471.134 5.69615L-472 5.19615L-469 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 0L-460.134 0.5L-463.134 5.69615L-464 5.19615L-461 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 0L-452.134 0.5L-455.134 5.69615L-456 5.19615L-453 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 0L-444.134 0.5L-447.134 5.69615L-448 5.19615L-445 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 0L-436.134 0.5L-439.134 5.69615L-440 5.19615L-437 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 0L-428.134 0.5L-431.134 5.69615L-432 5.19615L-429 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 0L-420.134 0.5L-423.134 5.69615L-424 5.19615L-421 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 0L-412.134 0.5L-415.134 5.69615L-416 5.19615L-413 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 0L-404.134 0.5L-407.134 5.69615L-408 5.19615L-405 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 0L-396.134 0.5L-399.134 5.69615L-400 5.19615L-397 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 0L-388.134 0.5L-391.134 5.69615L-392 5.19615L-389 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 0L-380.134 0.5L-383.134 5.69615L-384 5.19615L-381 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 0L-372.134 0.5L-375.134 5.69615L-376 5.19615L-373 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 0L-364.134 0.5L-367.134 5.69615L-368 5.19615L-365 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 0L-356.134 0.5L-359.134 5.69615L-360 5.19615L-357 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 0L-348.134 0.5L-351.134 5.69615L-352 5.19615L-349 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 0L-340.134 0.5L-343.134 5.69615L-344 5.19615L-341 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 0L-332.134 0.5L-335.134 5.69615L-336 5.19615L-333 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 0L-324.134 0.5L-327.134 5.69615L-328 5.19615L-325 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 0L-316.134 0.5L-319.134 5.69615L-320 5.19615L-317 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 0L-308.134 0.5L-311.134 5.69615L-312 5.19615L-309 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 0L-300.134 0.5L-303.134 5.69615L-304 5.19615L-301 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 0L-292.134 0.5L-295.134 5.69615L-296 5.19615L-293 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 0L-284.134 0.5L-287.134 5.69615L-288 5.19615L-285 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 0L-276.134 0.5L-279.134 5.69615L-280 5.19615L-277 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 0L-268.134 0.5L-271.134 5.69615L-272 5.19615L-269 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 0L-260.134 0.5L-263.134 5.69615L-264 5.19615L-261 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 0L-252.134 0.5L-255.134 5.69615L-256 5.19615L-253 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 0L-244.134 0.5L-247.134 5.69615L-248 5.19615L-245 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 0L-236.134 0.5L-239.134 5.69615L-240 5.19615L-237 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 0L-228.134 0.5L-231.134 5.69615L-232 5.19615L-229 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 0L-220.134 0.5L-223.134 5.69615L-224 5.19615L-221 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 0L-212.134 0.5L-215.134 5.69615L-216 5.19615L-213 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 0L-204.134 0.5L-207.134 5.69615L-208 5.19615L-205 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 0L-196.134 0.5L-199.134 5.69615L-200 5.19615L-197 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 0L-188.134 0.5L-191.134 5.69615L-192 5.19615L-189 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 0L-180.134 0.5L-183.134 5.69615L-184 5.19615L-181 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 0L-172.134 0.5L-175.134 5.69615L-176 5.19615L-173 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 0L-164.134 0.5L-167.134 5.69615L-168 5.19615L-165 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 0L-156.134 0.5L-159.134 5.69615L-160 5.19615L-157 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 0L-148.134 0.5L-151.134 5.69615L-152 5.19615L-149 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 0L-140.134 0.5L-143.134 5.69615L-144 5.19615L-141 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 8.00001L-556.134 8.50001L-559.134 13.6962L-560 13.1962L-557 8.00001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 8L-548.134 8.5L-551.134 13.6962L-552 13.1962L-549 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 8L-540.134 8.5L-543.134 13.6962L-544 13.1962L-541 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 8L-532.134 8.5L-535.134 13.6962L-536 13.1962L-533 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 8L-524.134 8.5L-527.134 13.6962L-528 13.1962L-525 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 8L-516.134 8.5L-519.134 13.6962L-520 13.1962L-517 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 8L-508.134 8.5L-511.134 13.6962L-512 13.1962L-509 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 8L-500.134 8.5L-503.134 13.6962L-504 13.1962L-501 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 8L-492.134 8.5L-495.134 13.6962L-496 13.1962L-493 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 8L-484.134 8.5L-487.134 13.6962L-488 13.1962L-485 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 8L-476.134 8.5L-479.134 13.6962L-480 13.1962L-477 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 8L-468.134 8.5L-471.134 13.6962L-472 13.1962L-469 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 8L-460.134 8.5L-463.134 13.6962L-464 13.1962L-461 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 8L-452.134 8.5L-455.134 13.6962L-456 13.1962L-453 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 8L-444.134 8.5L-447.134 13.6962L-448 13.1962L-445 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 8L-436.134 8.5L-439.134 13.6962L-440 13.1962L-437 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 8L-428.134 8.5L-431.134 13.6962L-432 13.1962L-429 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 8L-420.134 8.5L-423.134 13.6962L-424 13.1962L-421 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 8L-412.134 8.5L-415.134 13.6962L-416 13.1962L-413 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 8L-404.134 8.5L-407.134 13.6962L-408 13.1962L-405 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 8L-396.134 8.5L-399.134 13.6962L-400 13.1962L-397 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 8L-388.134 8.5L-391.134 13.6962L-392 13.1962L-389 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 8L-380.134 8.5L-383.134 13.6962L-384 13.1962L-381 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 8L-372.134 8.5L-375.134 13.6962L-376 13.1962L-373 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 8L-364.134 8.5L-367.134 13.6962L-368 13.1962L-365 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 8L-356.134 8.5L-359.134 13.6962L-360 13.1962L-357 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 8L-348.134 8.5L-351.134 13.6962L-352 13.1962L-349 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 8L-340.134 8.5L-343.134 13.6962L-344 13.1962L-341 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 8L-332.134 8.5L-335.134 13.6962L-336 13.1962L-333 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 8L-324.134 8.5L-327.134 13.6962L-328 13.1962L-325 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 8L-316.134 8.5L-319.134 13.6962L-320 13.1962L-317 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 8L-308.134 8.5L-311.134 13.6962L-312 13.1962L-309 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 8L-300.134 8.5L-303.134 13.6962L-304 13.1962L-301 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 8L-292.134 8.5L-295.134 13.6962L-296 13.1962L-293 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 8L-284.134 8.5L-287.134 13.6962L-288 13.1962L-285 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 8L-276.134 8.5L-279.134 13.6962L-280 13.1962L-277 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 8L-268.134 8.5L-271.134 13.6962L-272 13.1962L-269 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 8L-260.134 8.5L-263.134 13.6962L-264 13.1962L-261 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 8L-252.134 8.5L-255.134 13.6962L-256 13.1962L-253 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 8L-244.134 8.5L-247.134 13.6962L-248 13.1962L-245 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 8L-236.134 8.5L-239.134 13.6962L-240 13.1962L-237 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 8L-228.134 8.5L-231.134 13.6962L-232 13.1962L-229 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 8L-220.134 8.5L-223.134 13.6962L-224 13.1962L-221 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 8L-212.134 8.5L-215.134 13.6962L-216 13.1962L-213 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 8L-204.134 8.5L-207.134 13.6962L-208 13.1962L-205 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 8L-196.134 8.5L-199.134 13.6962L-200 13.1962L-197 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 8L-188.134 8.5L-191.134 13.6962L-192 13.1962L-189 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 8L-180.134 8.5L-183.134 13.6962L-184 13.1962L-181 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 8L-172.134 8.5L-175.134 13.6962L-176 13.1962L-173 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 8L-164.134 8.5L-167.134 13.6962L-168 13.1962L-165 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 8L-156.134 8.5L-159.134 13.6962L-160 13.1962L-157 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 8L-148.134 8.5L-151.134 13.6962L-152 13.1962L-149 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 8L-140.134 8.5L-143.134 13.6962L-144 13.1962L-141 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 16L-556.134 16.5L-559.134 21.6962L-560 21.1962L-557 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 16L-548.134 16.5L-551.134 21.6962L-552 21.1962L-549 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 16L-540.134 16.5L-543.134 21.6962L-544 21.1962L-541 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 16L-532.134 16.5L-535.134 21.6962L-536 21.1962L-533 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 16L-524.134 16.5L-527.134 21.6962L-528 21.1962L-525 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 16L-516.134 16.5L-519.134 21.6962L-520 21.1962L-517 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 16L-508.134 16.5L-511.134 21.6962L-512 21.1962L-509 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 16L-500.134 16.5L-503.134 21.6962L-504 21.1962L-501 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 16L-492.134 16.5L-495.134 21.6962L-496 21.1962L-493 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 16L-484.134 16.5L-487.134 21.6962L-488 21.1962L-485 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 16L-476.134 16.5L-479.134 21.6962L-480 21.1962L-477 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 16L-468.134 16.5L-471.134 21.6962L-472 21.1962L-469 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 16L-460.134 16.5L-463.134 21.6962L-464 21.1962L-461 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 16L-452.134 16.5L-455.134 21.6962L-456 21.1962L-453 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 16L-444.134 16.5L-447.134 21.6962L-448 21.1962L-445 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 16L-436.134 16.5L-439.134 21.6962L-440 21.1962L-437 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 16L-428.134 16.5L-431.134 21.6962L-432 21.1962L-429 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 16L-420.134 16.5L-423.134 21.6962L-424 21.1962L-421 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 16L-412.134 16.5L-415.134 21.6962L-416 21.1962L-413 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 16L-404.134 16.5L-407.134 21.6962L-408 21.1962L-405 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 16L-396.134 16.5L-399.134 21.6962L-400 21.1962L-397 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 16L-388.134 16.5L-391.134 21.6962L-392 21.1962L-389 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 16L-380.134 16.5L-383.134 21.6962L-384 21.1962L-381 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 16L-372.134 16.5L-375.134 21.6962L-376 21.1962L-373 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 16L-364.134 16.5L-367.134 21.6962L-368 21.1962L-365 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 16L-356.134 16.5L-359.134 21.6962L-360 21.1962L-357 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 16L-348.134 16.5L-351.134 21.6962L-352 21.1962L-349 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 16L-340.134 16.5L-343.134 21.6962L-344 21.1962L-341 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 16L-332.134 16.5L-335.134 21.6962L-336 21.1962L-333 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 16L-324.134 16.5L-327.134 21.6962L-328 21.1962L-325 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 16L-316.134 16.5L-319.134 21.6962L-320 21.1962L-317 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 16L-308.134 16.5L-311.134 21.6962L-312 21.1962L-309 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 16L-300.134 16.5L-303.134 21.6962L-304 21.1962L-301 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 16L-292.134 16.5L-295.134 21.6962L-296 21.1962L-293 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 16L-284.134 16.5L-287.134 21.6962L-288 21.1962L-285 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 16L-276.134 16.5L-279.134 21.6962L-280 21.1962L-277 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 16L-268.134 16.5L-271.134 21.6962L-272 21.1962L-269 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 16L-260.134 16.5L-263.134 21.6962L-264 21.1962L-261 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 16L-252.134 16.5L-255.134 21.6962L-256 21.1962L-253 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 16L-244.134 16.5L-247.134 21.6962L-248 21.1962L-245 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 16L-236.134 16.5L-239.134 21.6962L-240 21.1962L-237 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 16L-228.134 16.5L-231.134 21.6962L-232 21.1962L-229 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 16L-220.134 16.5L-223.134 21.6962L-224 21.1962L-221 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 16L-212.134 16.5L-215.134 21.6962L-216 21.1962L-213 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 16L-204.134 16.5L-207.134 21.6962L-208 21.1962L-205 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 16L-196.134 16.5L-199.134 21.6962L-200 21.1962L-197 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 16L-188.134 16.5L-191.134 21.6962L-192 21.1962L-189 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 16L-180.134 16.5L-183.134 21.6962L-184 21.1962L-181 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 16L-172.134 16.5L-175.134 21.6962L-176 21.1962L-173 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 16L-164.134 16.5L-167.134 21.6962L-168 21.1962L-165 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 16L-156.134 16.5L-159.134 21.6962L-160 21.1962L-157 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 16L-148.134 16.5L-151.134 21.6962L-152 21.1962L-149 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 16L-140.134 16.5L-143.134 21.6962L-144 21.1962L-141 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 24L-556.134 24.5L-559.134 29.6962L-560 29.1962L-557 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 24L-548.134 24.5L-551.134 29.6962L-552 29.1962L-549 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 24L-540.134 24.5L-543.134 29.6962L-544 29.1962L-541 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 24L-532.134 24.5L-535.134 29.6962L-536 29.1962L-533 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 24L-524.134 24.5L-527.134 29.6962L-528 29.1962L-525 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 24L-516.134 24.5L-519.134 29.6962L-520 29.1962L-517 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 24L-508.134 24.5L-511.134 29.6962L-512 29.1962L-509 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 24L-500.134 24.5L-503.134 29.6962L-504 29.1962L-501 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 24L-492.134 24.5L-495.134 29.6962L-496 29.1962L-493 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 24L-484.134 24.5L-487.134 29.6962L-488 29.1962L-485 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 24L-476.134 24.5L-479.134 29.6962L-480 29.1962L-477 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 24L-468.134 24.5L-471.134 29.6962L-472 29.1962L-469 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 24L-460.134 24.5L-463.134 29.6962L-464 29.1962L-461 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 24L-452.134 24.5L-455.134 29.6962L-456 29.1962L-453 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 24L-444.134 24.5L-447.134 29.6962L-448 29.1962L-445 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 24L-436.134 24.5L-439.134 29.6962L-440 29.1962L-437 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 24L-428.134 24.5L-431.134 29.6962L-432 29.1962L-429 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 24L-420.134 24.5L-423.134 29.6962L-424 29.1962L-421 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 24L-412.134 24.5L-415.134 29.6962L-416 29.1962L-413 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 24L-404.134 24.5L-407.134 29.6962L-408 29.1962L-405 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 24L-396.134 24.5L-399.134 29.6962L-400 29.1962L-397 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 24L-388.134 24.5L-391.134 29.6962L-392 29.1962L-389 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 24L-380.134 24.5L-383.134 29.6962L-384 29.1962L-381 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 24L-372.134 24.5L-375.134 29.6962L-376 29.1962L-373 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 24L-364.134 24.5L-367.134 29.6962L-368 29.1962L-365 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 24L-356.134 24.5L-359.134 29.6962L-360 29.1962L-357 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 24L-348.134 24.5L-351.134 29.6962L-352 29.1962L-349 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 24L-340.134 24.5L-343.134 29.6962L-344 29.1962L-341 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 24L-332.134 24.5L-335.134 29.6962L-336 29.1962L-333 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 24L-324.134 24.5L-327.134 29.6962L-328 29.1962L-325 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 24L-316.134 24.5L-319.134 29.6962L-320 29.1962L-317 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 24L-308.134 24.5L-311.134 29.6962L-312 29.1962L-309 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 24L-300.134 24.5L-303.134 29.6962L-304 29.1962L-301 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 24L-292.134 24.5L-295.134 29.6962L-296 29.1962L-293 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 24L-284.134 24.5L-287.134 29.6962L-288 29.1962L-285 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 24L-276.134 24.5L-279.134 29.6962L-280 29.1962L-277 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 24L-268.134 24.5L-271.134 29.6962L-272 29.1962L-269 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 24L-260.134 24.5L-263.134 29.6962L-264 29.1962L-261 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 24L-252.134 24.5L-255.134 29.6962L-256 29.1962L-253 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 24L-244.134 24.5L-247.134 29.6962L-248 29.1962L-245 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 24L-236.134 24.5L-239.134 29.6962L-240 29.1962L-237 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 24L-228.134 24.5L-231.134 29.6962L-232 29.1962L-229 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 24L-220.134 24.5L-223.134 29.6962L-224 29.1962L-221 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 24L-212.134 24.5L-215.134 29.6962L-216 29.1962L-213 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 24L-204.134 24.5L-207.134 29.6962L-208 29.1962L-205 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 24L-196.134 24.5L-199.134 29.6962L-200 29.1962L-197 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 24L-188.134 24.5L-191.134 29.6962L-192 29.1962L-189 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 24L-180.134 24.5L-183.134 29.6962L-184 29.1962L-181 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 24L-172.134 24.5L-175.134 29.6962L-176 29.1962L-173 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 24L-164.134 24.5L-167.134 29.6962L-168 29.1962L-165 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 24L-156.134 24.5L-159.134 29.6962L-160 29.1962L-157 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 24L-148.134 24.5L-151.134 29.6962L-152 29.1962L-149 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 24L-140.134 24.5L-143.134 29.6962L-144 29.1962L-141 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 32L-556.134 32.5L-559.134 37.6962L-560 37.1962L-557 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 32L-548.134 32.5L-551.134 37.6962L-552 37.1962L-549 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 32L-540.134 32.5L-543.134 37.6962L-544 37.1962L-541 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 32L-532.134 32.5L-535.134 37.6962L-536 37.1962L-533 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 32L-524.134 32.5L-527.134 37.6962L-528 37.1962L-525 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 32L-516.134 32.5L-519.134 37.6962L-520 37.1962L-517 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 32L-508.134 32.5L-511.134 37.6962L-512 37.1962L-509 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 32L-500.134 32.5L-503.134 37.6962L-504 37.1962L-501 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 32L-492.134 32.5L-495.134 37.6962L-496 37.1962L-493 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 32L-484.134 32.5L-487.134 37.6962L-488 37.1962L-485 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 32L-476.134 32.5L-479.134 37.6962L-480 37.1962L-477 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 32L-468.134 32.5L-471.134 37.6962L-472 37.1962L-469 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 32L-460.134 32.5L-463.134 37.6962L-464 37.1962L-461 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 32L-452.134 32.5L-455.134 37.6962L-456 37.1962L-453 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 32L-444.134 32.5L-447.134 37.6962L-448 37.1962L-445 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 32L-436.134 32.5L-439.134 37.6962L-440 37.1962L-437 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 32L-428.134 32.5L-431.134 37.6962L-432 37.1962L-429 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 32L-420.134 32.5L-423.134 37.6962L-424 37.1962L-421 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 32L-412.134 32.5L-415.134 37.6962L-416 37.1962L-413 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 32L-404.134 32.5L-407.134 37.6962L-408 37.1962L-405 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 32L-396.134 32.5L-399.134 37.6962L-400 37.1962L-397 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 32L-388.134 32.5L-391.134 37.6962L-392 37.1962L-389 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 32L-380.134 32.5L-383.134 37.6962L-384 37.1962L-381 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 32L-372.134 32.5L-375.134 37.6962L-376 37.1962L-373 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 32L-364.134 32.5L-367.134 37.6962L-368 37.1962L-365 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 32L-356.134 32.5L-359.134 37.6962L-360 37.1962L-357 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 32L-348.134 32.5L-351.134 37.6962L-352 37.1962L-349 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 32L-340.134 32.5L-343.134 37.6962L-344 37.1962L-341 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 32L-332.134 32.5L-335.134 37.6962L-336 37.1962L-333 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 32L-324.134 32.5L-327.134 37.6962L-328 37.1962L-325 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 32L-316.134 32.5L-319.134 37.6962L-320 37.1962L-317 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 32L-308.134 32.5L-311.134 37.6962L-312 37.1962L-309 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 32L-300.134 32.5L-303.134 37.6962L-304 37.1962L-301 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 32L-292.134 32.5L-295.134 37.6962L-296 37.1962L-293 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 32L-284.134 32.5L-287.134 37.6962L-288 37.1962L-285 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 32L-276.134 32.5L-279.134 37.6962L-280 37.1962L-277 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 32L-268.134 32.5L-271.134 37.6962L-272 37.1962L-269 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 32L-260.134 32.5L-263.134 37.6962L-264 37.1962L-261 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 32L-252.134 32.5L-255.134 37.6962L-256 37.1962L-253 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 32L-244.134 32.5L-247.134 37.6962L-248 37.1962L-245 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 32L-236.134 32.5L-239.134 37.6962L-240 37.1962L-237 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 32L-228.134 32.5L-231.134 37.6962L-232 37.1962L-229 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 32L-220.134 32.5L-223.134 37.6962L-224 37.1962L-221 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 32L-212.134 32.5L-215.134 37.6962L-216 37.1962L-213 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 32L-204.134 32.5L-207.134 37.6962L-208 37.1962L-205 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 32L-196.134 32.5L-199.134 37.6962L-200 37.1962L-197 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 32L-188.134 32.5L-191.134 37.6962L-192 37.1962L-189 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 32L-180.134 32.5L-183.134 37.6962L-184 37.1962L-181 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 32L-172.134 32.5L-175.134 37.6962L-176 37.1962L-173 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 32L-164.134 32.5L-167.134 37.6962L-168 37.1962L-165 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 32L-156.134 32.5L-159.134 37.6962L-160 37.1962L-157 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 32L-148.134 32.5L-151.134 37.6962L-152 37.1962L-149 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 32L-140.134 32.5L-143.134 37.6962L-144 37.1962L-141 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 40L-556.134 40.5L-559.134 45.6962L-560 45.1962L-557 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 40L-548.134 40.5L-551.134 45.6962L-552 45.1962L-549 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 40L-540.134 40.5L-543.134 45.6962L-544 45.1962L-541 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 40L-532.134 40.5L-535.134 45.6962L-536 45.1962L-533 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 40L-524.134 40.5L-527.134 45.6962L-528 45.1962L-525 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 40L-516.134 40.5L-519.134 45.6962L-520 45.1962L-517 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 40L-508.134 40.5L-511.134 45.6962L-512 45.1962L-509 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 40L-500.134 40.5L-503.134 45.6962L-504 45.1962L-501 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 40L-492.134 40.5L-495.134 45.6962L-496 45.1962L-493 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 40L-484.134 40.5L-487.134 45.6962L-488 45.1962L-485 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 40L-476.134 40.5L-479.134 45.6962L-480 45.1962L-477 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 40L-468.134 40.5L-471.134 45.6962L-472 45.1962L-469 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 40L-460.134 40.5L-463.134 45.6962L-464 45.1962L-461 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 40L-452.134 40.5L-455.134 45.6962L-456 45.1962L-453 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 40L-444.134 40.5L-447.134 45.6962L-448 45.1962L-445 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 40L-436.134 40.5L-439.134 45.6962L-440 45.1962L-437 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 40L-428.134 40.5L-431.134 45.6962L-432 45.1962L-429 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 40L-420.134 40.5L-423.134 45.6962L-424 45.1962L-421 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 40L-412.134 40.5L-415.134 45.6962L-416 45.1962L-413 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 40L-404.134 40.5L-407.134 45.6962L-408 45.1962L-405 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 40L-396.134 40.5L-399.134 45.6962L-400 45.1962L-397 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 40L-388.134 40.5L-391.134 45.6962L-392 45.1962L-389 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 40L-380.134 40.5L-383.134 45.6962L-384 45.1962L-381 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 40L-372.134 40.5L-375.134 45.6962L-376 45.1962L-373 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 40L-364.134 40.5L-367.134 45.6962L-368 45.1962L-365 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 40L-356.134 40.5L-359.134 45.6962L-360 45.1962L-357 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 40L-348.134 40.5L-351.134 45.6962L-352 45.1962L-349 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 40L-340.134 40.5L-343.134 45.6962L-344 45.1962L-341 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 40L-332.134 40.5L-335.134 45.6962L-336 45.1962L-333 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 40L-324.134 40.5L-327.134 45.6962L-328 45.1962L-325 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 40L-316.134 40.5L-319.134 45.6962L-320 45.1962L-317 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 40L-308.134 40.5L-311.134 45.6962L-312 45.1962L-309 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 40L-300.134 40.5L-303.134 45.6962L-304 45.1962L-301 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 40L-292.134 40.5L-295.134 45.6962L-296 45.1962L-293 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 40L-284.134 40.5L-287.134 45.6962L-288 45.1962L-285 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 40L-276.134 40.5L-279.134 45.6962L-280 45.1962L-277 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 40L-268.134 40.5L-271.134 45.6962L-272 45.1962L-269 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 40L-260.134 40.5L-263.134 45.6962L-264 45.1962L-261 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 40L-252.134 40.5L-255.134 45.6962L-256 45.1962L-253 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 40L-244.134 40.5L-247.134 45.6962L-248 45.1962L-245 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 40L-236.134 40.5L-239.134 45.6962L-240 45.1962L-237 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 40L-228.134 40.5L-231.134 45.6962L-232 45.1962L-229 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 40L-220.134 40.5L-223.134 45.6962L-224 45.1962L-221 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 40L-212.134 40.5L-215.134 45.6962L-216 45.1962L-213 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 40L-204.134 40.5L-207.134 45.6962L-208 45.1962L-205 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 40L-196.134 40.5L-199.134 45.6962L-200 45.1962L-197 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 40L-188.134 40.5L-191.134 45.6962L-192 45.1962L-189 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 40L-180.134 40.5L-183.134 45.6962L-184 45.1962L-181 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 40L-172.134 40.5L-175.134 45.6962L-176 45.1962L-173 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 40L-164.134 40.5L-167.134 45.6962L-168 45.1962L-165 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 40L-156.134 40.5L-159.134 45.6962L-160 45.1962L-157 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 40L-148.134 40.5L-151.134 45.6962L-152 45.1962L-149 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 40L-140.134 40.5L-143.134 45.6962L-144 45.1962L-141 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 48L-556.134 48.5L-559.134 53.6962L-560 53.1962L-557 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 48L-548.134 48.5L-551.134 53.6962L-552 53.1962L-549 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 48L-540.134 48.5L-543.134 53.6962L-544 53.1962L-541 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 48L-532.134 48.5L-535.134 53.6962L-536 53.1962L-533 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 48L-524.134 48.5L-527.134 53.6962L-528 53.1962L-525 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 48L-516.134 48.5L-519.134 53.6962L-520 53.1962L-517 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 48L-508.134 48.5L-511.134 53.6962L-512 53.1962L-509 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 48L-500.134 48.5L-503.134 53.6962L-504 53.1962L-501 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 48L-492.134 48.5L-495.134 53.6962L-496 53.1962L-493 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 48L-484.134 48.5L-487.134 53.6962L-488 53.1962L-485 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 48L-476.134 48.5L-479.134 53.6962L-480 53.1962L-477 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 48L-468.134 48.5L-471.134 53.6962L-472 53.1962L-469 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 48L-460.134 48.5L-463.134 53.6962L-464 53.1962L-461 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 48L-452.134 48.5L-455.134 53.6962L-456 53.1962L-453 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 48L-444.134 48.5L-447.134 53.6962L-448 53.1962L-445 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 48L-436.134 48.5L-439.134 53.6962L-440 53.1962L-437 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 48L-428.134 48.5L-431.134 53.6962L-432 53.1962L-429 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 48L-420.134 48.5L-423.134 53.6962L-424 53.1962L-421 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 48L-412.134 48.5L-415.134 53.6962L-416 53.1962L-413 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 48L-404.134 48.5L-407.134 53.6962L-408 53.1962L-405 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 48L-396.134 48.5L-399.134 53.6962L-400 53.1962L-397 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 48L-388.134 48.5L-391.134 53.6962L-392 53.1962L-389 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 48L-380.134 48.5L-383.134 53.6962L-384 53.1962L-381 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 48L-372.134 48.5L-375.134 53.6962L-376 53.1962L-373 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 48L-364.134 48.5L-367.134 53.6962L-368 53.1962L-365 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 48L-356.134 48.5L-359.134 53.6962L-360 53.1962L-357 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 48L-348.134 48.5L-351.134 53.6962L-352 53.1962L-349 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 48L-340.134 48.5L-343.134 53.6962L-344 53.1962L-341 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 48L-332.134 48.5L-335.134 53.6962L-336 53.1962L-333 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 48L-324.134 48.5L-327.134 53.6962L-328 53.1962L-325 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 48L-316.134 48.5L-319.134 53.6962L-320 53.1962L-317 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 48L-308.134 48.5L-311.134 53.6962L-312 53.1962L-309 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 48L-300.134 48.5L-303.134 53.6962L-304 53.1962L-301 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 48L-292.134 48.5L-295.134 53.6962L-296 53.1962L-293 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 48L-284.134 48.5L-287.134 53.6962L-288 53.1962L-285 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 48L-276.134 48.5L-279.134 53.6962L-280 53.1962L-277 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 48L-268.134 48.5L-271.134 53.6962L-272 53.1962L-269 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 48L-260.134 48.5L-263.134 53.6962L-264 53.1962L-261 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 48L-252.134 48.5L-255.134 53.6962L-256 53.1962L-253 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 48L-244.134 48.5L-247.134 53.6962L-248 53.1962L-245 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 48L-236.134 48.5L-239.134 53.6962L-240 53.1962L-237 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 48L-228.134 48.5L-231.134 53.6962L-232 53.1962L-229 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 48L-220.134 48.5L-223.134 53.6962L-224 53.1962L-221 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 48L-212.134 48.5L-215.134 53.6962L-216 53.1962L-213 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 48L-204.134 48.5L-207.134 53.6962L-208 53.1962L-205 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 48L-196.134 48.5L-199.134 53.6962L-200 53.1962L-197 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 48L-188.134 48.5L-191.134 53.6962L-192 53.1962L-189 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 48L-180.134 48.5L-183.134 53.6962L-184 53.1962L-181 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 48L-172.134 48.5L-175.134 53.6962L-176 53.1962L-173 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 48L-164.134 48.5L-167.134 53.6962L-168 53.1962L-165 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 48L-156.134 48.5L-159.134 53.6962L-160 53.1962L-157 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 48L-148.134 48.5L-151.134 53.6962L-152 53.1962L-149 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 48L-140.134 48.5L-143.134 53.6962L-144 53.1962L-141 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 56L-556.134 56.5L-559.134 61.6962L-560 61.1962L-557 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 56L-548.134 56.5L-551.134 61.6962L-552 61.1962L-549 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 56L-540.134 56.5L-543.134 61.6962L-544 61.1962L-541 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 56L-532.134 56.5L-535.134 61.6962L-536 61.1962L-533 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 56L-524.134 56.5L-527.134 61.6962L-528 61.1962L-525 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 56L-516.134 56.5L-519.134 61.6962L-520 61.1962L-517 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 56L-508.134 56.5L-511.134 61.6962L-512 61.1962L-509 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 56L-500.134 56.5L-503.134 61.6962L-504 61.1962L-501 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 56L-492.134 56.5L-495.134 61.6962L-496 61.1962L-493 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 56L-484.134 56.5L-487.134 61.6962L-488 61.1962L-485 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 56L-476.134 56.5L-479.134 61.6962L-480 61.1962L-477 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 56L-468.134 56.5L-471.134 61.6962L-472 61.1962L-469 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 56L-460.134 56.5L-463.134 61.6962L-464 61.1962L-461 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 56L-452.134 56.5L-455.134 61.6962L-456 61.1962L-453 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 56L-444.134 56.5L-447.134 61.6962L-448 61.1962L-445 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 56L-436.134 56.5L-439.134 61.6962L-440 61.1962L-437 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 56L-428.134 56.5L-431.134 61.6962L-432 61.1962L-429 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 56L-420.134 56.5L-423.134 61.6962L-424 61.1962L-421 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 56L-412.134 56.5L-415.134 61.6962L-416 61.1962L-413 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 56L-404.134 56.5L-407.134 61.6962L-408 61.1962L-405 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 56L-396.134 56.5L-399.134 61.6962L-400 61.1962L-397 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 56L-388.134 56.5L-391.134 61.6962L-392 61.1962L-389 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 56L-380.134 56.5L-383.134 61.6962L-384 61.1962L-381 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 56L-372.134 56.5L-375.134 61.6962L-376 61.1962L-373 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 56L-364.134 56.5L-367.134 61.6962L-368 61.1962L-365 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 56L-356.134 56.5L-359.134 61.6962L-360 61.1962L-357 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 56L-348.134 56.5L-351.134 61.6962L-352 61.1962L-349 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 56L-340.134 56.5L-343.134 61.6962L-344 61.1962L-341 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 56L-332.134 56.5L-335.134 61.6962L-336 61.1962L-333 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 56L-324.134 56.5L-327.134 61.6962L-328 61.1962L-325 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 56L-316.134 56.5L-319.134 61.6962L-320 61.1962L-317 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 56L-308.134 56.5L-311.134 61.6962L-312 61.1962L-309 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 56L-300.134 56.5L-303.134 61.6962L-304 61.1962L-301 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 56L-292.134 56.5L-295.134 61.6962L-296 61.1962L-293 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 56L-284.134 56.5L-287.134 61.6962L-288 61.1962L-285 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 56L-276.134 56.5L-279.134 61.6962L-280 61.1962L-277 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 56L-268.134 56.5L-271.134 61.6962L-272 61.1962L-269 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 56L-260.134 56.5L-263.134 61.6962L-264 61.1962L-261 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 56L-252.134 56.5L-255.134 61.6962L-256 61.1962L-253 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 56L-244.134 56.5L-247.134 61.6962L-248 61.1962L-245 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 56L-236.134 56.5L-239.134 61.6962L-240 61.1962L-237 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 56L-228.134 56.5L-231.134 61.6962L-232 61.1962L-229 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 56L-220.134 56.5L-223.134 61.6962L-224 61.1962L-221 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 56L-212.134 56.5L-215.134 61.6962L-216 61.1962L-213 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 56L-204.134 56.5L-207.134 61.6962L-208 61.1962L-205 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 56L-196.134 56.5L-199.134 61.6962L-200 61.1962L-197 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 56L-188.134 56.5L-191.134 61.6962L-192 61.1962L-189 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 56L-180.134 56.5L-183.134 61.6962L-184 61.1962L-181 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 56L-172.134 56.5L-175.134 61.6962L-176 61.1962L-173 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 56L-164.134 56.5L-167.134 61.6962L-168 61.1962L-165 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 56L-156.134 56.5L-159.134 61.6962L-160 61.1962L-157 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 56L-148.134 56.5L-151.134 61.6962L-152 61.1962L-149 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 56L-140.134 56.5L-143.134 61.6962L-144 61.1962L-141 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 64L-556.134 64.5L-559.134 69.6962L-560 69.1962L-557 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 64L-548.134 64.5L-551.134 69.6962L-552 69.1962L-549 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 64L-540.134 64.5L-543.134 69.6962L-544 69.1962L-541 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 64L-532.134 64.5L-535.134 69.6962L-536 69.1962L-533 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 64L-524.134 64.5L-527.134 69.6962L-528 69.1962L-525 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 64L-516.134 64.5L-519.134 69.6962L-520 69.1962L-517 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 64L-508.134 64.5L-511.134 69.6962L-512 69.1962L-509 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 64L-500.134 64.5L-503.134 69.6962L-504 69.1962L-501 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 64L-492.134 64.5L-495.134 69.6962L-496 69.1962L-493 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 64L-484.134 64.5L-487.134 69.6962L-488 69.1962L-485 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 64L-476.134 64.5L-479.134 69.6962L-480 69.1962L-477 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 64L-468.134 64.5L-471.134 69.6962L-472 69.1962L-469 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 64L-460.134 64.5L-463.134 69.6962L-464 69.1962L-461 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 64L-452.134 64.5L-455.134 69.6962L-456 69.1962L-453 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 64L-444.134 64.5L-447.134 69.6962L-448 69.1962L-445 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 64L-436.134 64.5L-439.134 69.6962L-440 69.1962L-437 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 64L-428.134 64.5L-431.134 69.6962L-432 69.1962L-429 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 64L-420.134 64.5L-423.134 69.6962L-424 69.1962L-421 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 64L-412.134 64.5L-415.134 69.6962L-416 69.1962L-413 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 64L-404.134 64.5L-407.134 69.6962L-408 69.1962L-405 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 64L-396.134 64.5L-399.134 69.6962L-400 69.1962L-397 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 64L-388.134 64.5L-391.134 69.6962L-392 69.1962L-389 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 64L-380.134 64.5L-383.134 69.6962L-384 69.1962L-381 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 64L-372.134 64.5L-375.134 69.6962L-376 69.1962L-373 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 64L-364.134 64.5L-367.134 69.6962L-368 69.1962L-365 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 64L-356.134 64.5L-359.134 69.6962L-360 69.1962L-357 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 64L-348.134 64.5L-351.134 69.6962L-352 69.1962L-349 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 64L-340.134 64.5L-343.134 69.6962L-344 69.1962L-341 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 64L-332.134 64.5L-335.134 69.6962L-336 69.1962L-333 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 64L-324.134 64.5L-327.134 69.6962L-328 69.1962L-325 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 64L-316.134 64.5L-319.134 69.6962L-320 69.1962L-317 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 64L-308.134 64.5L-311.134 69.6962L-312 69.1962L-309 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 64L-300.134 64.5L-303.134 69.6962L-304 69.1962L-301 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 64L-292.134 64.5L-295.134 69.6962L-296 69.1962L-293 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 64L-284.134 64.5L-287.134 69.6962L-288 69.1962L-285 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 64L-276.134 64.5L-279.134 69.6962L-280 69.1962L-277 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 64L-268.134 64.5L-271.134 69.6962L-272 69.1962L-269 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 64L-260.134 64.5L-263.134 69.6962L-264 69.1962L-261 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 64L-252.134 64.5L-255.134 69.6962L-256 69.1962L-253 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 64L-244.134 64.5L-247.134 69.6962L-248 69.1962L-245 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 64L-236.134 64.5L-239.134 69.6962L-240 69.1962L-237 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 64L-228.134 64.5L-231.134 69.6962L-232 69.1962L-229 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 64L-220.134 64.5L-223.134 69.6962L-224 69.1962L-221 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 64L-212.134 64.5L-215.134 69.6962L-216 69.1962L-213 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 64L-204.134 64.5L-207.134 69.6962L-208 69.1962L-205 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 64L-196.134 64.5L-199.134 69.6962L-200 69.1962L-197 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 64L-188.134 64.5L-191.134 69.6962L-192 69.1962L-189 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 64L-180.134 64.5L-183.134 69.6962L-184 69.1962L-181 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 64L-172.134 64.5L-175.134 69.6962L-176 69.1962L-173 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 64L-164.134 64.5L-167.134 69.6962L-168 69.1962L-165 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 64L-156.134 64.5L-159.134 69.6962L-160 69.1962L-157 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 64L-148.134 64.5L-151.134 69.6962L-152 69.1962L-149 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 64L-140.134 64.5L-143.134 69.6962L-144 69.1962L-141 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 72L-556.134 72.5L-559.134 77.6962L-560 77.1962L-557 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 72L-548.134 72.5L-551.134 77.6962L-552 77.1962L-549 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 72L-540.134 72.5L-543.134 77.6962L-544 77.1962L-541 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 72L-532.134 72.5L-535.134 77.6962L-536 77.1962L-533 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 72L-524.134 72.5L-527.134 77.6962L-528 77.1962L-525 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 72L-516.134 72.5L-519.134 77.6962L-520 77.1962L-517 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 72L-508.134 72.5L-511.134 77.6962L-512 77.1962L-509 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 72L-500.134 72.5L-503.134 77.6962L-504 77.1962L-501 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 72L-492.134 72.5L-495.134 77.6962L-496 77.1962L-493 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 72L-484.134 72.5L-487.134 77.6962L-488 77.1962L-485 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 72L-476.134 72.5L-479.134 77.6962L-480 77.1962L-477 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 72L-468.134 72.5L-471.134 77.6962L-472 77.1962L-469 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 72L-460.134 72.5L-463.134 77.6962L-464 77.1962L-461 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 72L-452.134 72.5L-455.134 77.6962L-456 77.1962L-453 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 72L-444.134 72.5L-447.134 77.6962L-448 77.1962L-445 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 72L-436.134 72.5L-439.134 77.6962L-440 77.1962L-437 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 72L-428.134 72.5L-431.134 77.6962L-432 77.1962L-429 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 72L-420.134 72.5L-423.134 77.6962L-424 77.1962L-421 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 72L-412.134 72.5L-415.134 77.6962L-416 77.1962L-413 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 72L-404.134 72.5L-407.134 77.6962L-408 77.1962L-405 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 72L-396.134 72.5L-399.134 77.6962L-400 77.1962L-397 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 72L-388.134 72.5L-391.134 77.6962L-392 77.1962L-389 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 72L-380.134 72.5L-383.134 77.6962L-384 77.1962L-381 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 72L-372.134 72.5L-375.134 77.6962L-376 77.1962L-373 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 72L-364.134 72.5L-367.134 77.6962L-368 77.1962L-365 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 72L-356.134 72.5L-359.134 77.6962L-360 77.1962L-357 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 72L-348.134 72.5L-351.134 77.6962L-352 77.1962L-349 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 72L-340.134 72.5L-343.134 77.6962L-344 77.1962L-341 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 72L-332.134 72.5L-335.134 77.6962L-336 77.1962L-333 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 72L-324.134 72.5L-327.134 77.6962L-328 77.1962L-325 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 72L-316.134 72.5L-319.134 77.6962L-320 77.1962L-317 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 72L-308.134 72.5L-311.134 77.6962L-312 77.1962L-309 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 72L-300.134 72.5L-303.134 77.6962L-304 77.1962L-301 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 72L-292.134 72.5L-295.134 77.6962L-296 77.1962L-293 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 72L-284.134 72.5L-287.134 77.6962L-288 77.1962L-285 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 72L-276.134 72.5L-279.134 77.6962L-280 77.1962L-277 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 72L-268.134 72.5L-271.134 77.6962L-272 77.1962L-269 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 72L-260.134 72.5L-263.134 77.6962L-264 77.1962L-261 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 72L-252.134 72.5L-255.134 77.6962L-256 77.1962L-253 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 72L-244.134 72.5L-247.134 77.6962L-248 77.1962L-245 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 72L-236.134 72.5L-239.134 77.6962L-240 77.1962L-237 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 72L-228.134 72.5L-231.134 77.6962L-232 77.1962L-229 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 72L-220.134 72.5L-223.134 77.6962L-224 77.1962L-221 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 72L-212.134 72.5L-215.134 77.6962L-216 77.1962L-213 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 72L-204.134 72.5L-207.134 77.6962L-208 77.1962L-205 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 72L-196.134 72.5L-199.134 77.6962L-200 77.1962L-197 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 72L-188.134 72.5L-191.134 77.6962L-192 77.1962L-189 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 72L-180.134 72.5L-183.134 77.6962L-184 77.1962L-181 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 72L-172.134 72.5L-175.134 77.6962L-176 77.1962L-173 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 72L-164.134 72.5L-167.134 77.6962L-168 77.1962L-165 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 72L-156.134 72.5L-159.134 77.6962L-160 77.1962L-157 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 72L-148.134 72.5L-151.134 77.6962L-152 77.1962L-149 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 72L-140.134 72.5L-143.134 77.6962L-144 77.1962L-141 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 80L-556.134 80.5L-559.134 85.6962L-560 85.1962L-557 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 80L-548.134 80.5L-551.134 85.6962L-552 85.1962L-549 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 80L-540.134 80.5L-543.134 85.6962L-544 85.1962L-541 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 80L-532.134 80.5L-535.134 85.6962L-536 85.1962L-533 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 80L-524.134 80.5L-527.134 85.6962L-528 85.1962L-525 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 80L-516.134 80.5L-519.134 85.6962L-520 85.1962L-517 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 80L-508.134 80.5L-511.134 85.6962L-512 85.1962L-509 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 80L-500.134 80.5L-503.134 85.6962L-504 85.1962L-501 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 80L-492.134 80.5L-495.134 85.6962L-496 85.1962L-493 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 80L-484.134 80.5L-487.134 85.6962L-488 85.1962L-485 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 80L-476.134 80.5L-479.134 85.6962L-480 85.1962L-477 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 80L-468.134 80.5L-471.134 85.6962L-472 85.1962L-469 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 80L-460.134 80.5L-463.134 85.6962L-464 85.1962L-461 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 80L-452.134 80.5L-455.134 85.6962L-456 85.1962L-453 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 80L-444.134 80.5L-447.134 85.6962L-448 85.1962L-445 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 80L-436.134 80.5L-439.134 85.6962L-440 85.1962L-437 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 80L-428.134 80.5L-431.134 85.6962L-432 85.1962L-429 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 80L-420.134 80.5L-423.134 85.6962L-424 85.1962L-421 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 80L-412.134 80.5L-415.134 85.6962L-416 85.1962L-413 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 80L-404.134 80.5L-407.134 85.6962L-408 85.1962L-405 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 80L-396.134 80.5L-399.134 85.6962L-400 85.1962L-397 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 80L-388.134 80.5L-391.134 85.6962L-392 85.1962L-389 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 80L-380.134 80.5L-383.134 85.6962L-384 85.1962L-381 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 80L-372.134 80.5L-375.134 85.6962L-376 85.1962L-373 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 80L-364.134 80.5L-367.134 85.6962L-368 85.1962L-365 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 80L-356.134 80.5L-359.134 85.6962L-360 85.1962L-357 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 80L-348.134 80.5L-351.134 85.6962L-352 85.1962L-349 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 80L-340.134 80.5L-343.134 85.6962L-344 85.1962L-341 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 80L-332.134 80.5L-335.134 85.6962L-336 85.1962L-333 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 80L-324.134 80.5L-327.134 85.6962L-328 85.1962L-325 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 80L-316.134 80.5L-319.134 85.6962L-320 85.1962L-317 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 80L-308.134 80.5L-311.134 85.6962L-312 85.1962L-309 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 80L-300.134 80.5L-303.134 85.6962L-304 85.1962L-301 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 80L-292.134 80.5L-295.134 85.6962L-296 85.1962L-293 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 80L-284.134 80.5L-287.134 85.6962L-288 85.1962L-285 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 80L-276.134 80.5L-279.134 85.6962L-280 85.1962L-277 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 80L-268.134 80.5L-271.134 85.6962L-272 85.1962L-269 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 80L-260.134 80.5L-263.134 85.6962L-264 85.1962L-261 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 80L-252.134 80.5L-255.134 85.6962L-256 85.1962L-253 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 80L-244.134 80.5L-247.134 85.6962L-248 85.1962L-245 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 80L-236.134 80.5L-239.134 85.6962L-240 85.1962L-237 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 80L-228.134 80.5L-231.134 85.6962L-232 85.1962L-229 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 80L-220.134 80.5L-223.134 85.6962L-224 85.1962L-221 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 80L-212.134 80.5L-215.134 85.6962L-216 85.1962L-213 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 80L-204.134 80.5L-207.134 85.6962L-208 85.1962L-205 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 80L-196.134 80.5L-199.134 85.6962L-200 85.1962L-197 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 80L-188.134 80.5L-191.134 85.6962L-192 85.1962L-189 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 80L-180.134 80.5L-183.134 85.6962L-184 85.1962L-181 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 80L-172.134 80.5L-175.134 85.6962L-176 85.1962L-173 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 80L-164.134 80.5L-167.134 85.6962L-168 85.1962L-165 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 80L-156.134 80.5L-159.134 85.6962L-160 85.1962L-157 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 80L-148.134 80.5L-151.134 85.6962L-152 85.1962L-149 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 80L-140.134 80.5L-143.134 85.6962L-144 85.1962L-141 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 88L-556.134 88.5L-559.134 93.6962L-560 93.1962L-557 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 88L-548.134 88.5L-551.134 93.6962L-552 93.1962L-549 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 88L-540.134 88.5L-543.134 93.6962L-544 93.1962L-541 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 88L-532.134 88.5L-535.134 93.6962L-536 93.1962L-533 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 88L-524.134 88.5L-527.134 93.6962L-528 93.1962L-525 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 88L-516.134 88.5L-519.134 93.6962L-520 93.1962L-517 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 88L-508.134 88.5L-511.134 93.6962L-512 93.1962L-509 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 88L-500.134 88.5L-503.134 93.6962L-504 93.1962L-501 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 88L-492.134 88.5L-495.134 93.6962L-496 93.1962L-493 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 88L-484.134 88.5L-487.134 93.6962L-488 93.1962L-485 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 88L-476.134 88.5L-479.134 93.6962L-480 93.1962L-477 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 88L-468.134 88.5L-471.134 93.6962L-472 93.1962L-469 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 88L-460.134 88.5L-463.134 93.6962L-464 93.1962L-461 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 88L-452.134 88.5L-455.134 93.6962L-456 93.1962L-453 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 88L-444.134 88.5L-447.134 93.6962L-448 93.1962L-445 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 88L-436.134 88.5L-439.134 93.6962L-440 93.1962L-437 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 88L-428.134 88.5L-431.134 93.6962L-432 93.1962L-429 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 88L-420.134 88.5L-423.134 93.6962L-424 93.1962L-421 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 88L-412.134 88.5L-415.134 93.6962L-416 93.1962L-413 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 88L-404.134 88.5L-407.134 93.6962L-408 93.1962L-405 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 88L-396.134 88.5L-399.134 93.6962L-400 93.1962L-397 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 88L-388.134 88.5L-391.134 93.6962L-392 93.1962L-389 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 88L-380.134 88.5L-383.134 93.6962L-384 93.1962L-381 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 88L-372.134 88.5L-375.134 93.6962L-376 93.1962L-373 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 88L-364.134 88.5L-367.134 93.6962L-368 93.1962L-365 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 88L-356.134 88.5L-359.134 93.6962L-360 93.1962L-357 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 88L-348.134 88.5L-351.134 93.6962L-352 93.1962L-349 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 88L-340.134 88.5L-343.134 93.6962L-344 93.1962L-341 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 88L-332.134 88.5L-335.134 93.6962L-336 93.1962L-333 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 88L-324.134 88.5L-327.134 93.6962L-328 93.1962L-325 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 88L-316.134 88.5L-319.134 93.6962L-320 93.1962L-317 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 88L-308.134 88.5L-311.134 93.6962L-312 93.1962L-309 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 88L-300.134 88.5L-303.134 93.6962L-304 93.1962L-301 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 88L-292.134 88.5L-295.134 93.6962L-296 93.1962L-293 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 88L-284.134 88.5L-287.134 93.6962L-288 93.1962L-285 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 88L-276.134 88.5L-279.134 93.6962L-280 93.1962L-277 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 88L-268.134 88.5L-271.134 93.6962L-272 93.1962L-269 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 88L-260.134 88.5L-263.134 93.6962L-264 93.1962L-261 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 88L-252.134 88.5L-255.134 93.6962L-256 93.1962L-253 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 88L-244.134 88.5L-247.134 93.6962L-248 93.1962L-245 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 88L-236.134 88.5L-239.134 93.6962L-240 93.1962L-237 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 88L-228.134 88.5L-231.134 93.6962L-232 93.1962L-229 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 88L-220.134 88.5L-223.134 93.6962L-224 93.1962L-221 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 88L-212.134 88.5L-215.134 93.6962L-216 93.1962L-213 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 88L-204.134 88.5L-207.134 93.6962L-208 93.1962L-205 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 88L-196.134 88.5L-199.134 93.6962L-200 93.1962L-197 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 88L-188.134 88.5L-191.134 93.6962L-192 93.1962L-189 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 88L-180.134 88.5L-183.134 93.6962L-184 93.1962L-181 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 88L-172.134 88.5L-175.134 93.6962L-176 93.1962L-173 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 88L-164.134 88.5L-167.134 93.6962L-168 93.1962L-165 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 88L-156.134 88.5L-159.134 93.6962L-160 93.1962L-157 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 88L-148.134 88.5L-151.134 93.6962L-152 93.1962L-149 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 88L-140.134 88.5L-143.134 93.6962L-144 93.1962L-141 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557 96L-556.134 96.5L-559.134 101.696L-560 101.196L-557 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549 96L-548.134 96.5L-551.134 101.696L-552 101.196L-549 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-541 96L-540.134 96.5L-543.134 101.696L-544 101.196L-541 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 96L-532.134 96.5L-535.134 101.696L-536 101.196L-533 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 96L-524.134 96.5L-527.134 101.696L-528 101.196L-525 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517 96L-516.134 96.5L-519.134 101.696L-520 101.196L-517 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-509 96L-508.134 96.5L-511.134 101.696L-512 101.196L-509 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-501 96L-500.134 96.5L-503.134 101.696L-504 101.196L-501 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-493 96L-492.134 96.5L-495.134 101.696L-496 101.196L-493 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 96L-484.134 96.5L-487.134 101.696L-488 101.196L-485 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-477 96L-476.134 96.5L-479.134 101.696L-480 101.196L-477 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-469 96L-468.134 96.5L-471.134 101.696L-472 101.196L-469 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461 96L-460.134 96.5L-463.134 101.696L-464 101.196L-461 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-453 96L-452.134 96.5L-455.134 101.696L-456 101.196L-453 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 96L-444.134 96.5L-447.134 101.696L-448 101.196L-445 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437 96L-436.134 96.5L-439.134 101.696L-440 101.196L-437 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-429 96L-428.134 96.5L-431.134 101.696L-432 101.196L-429 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421 96L-420.134 96.5L-423.134 101.696L-424 101.196L-421 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-413 96L-412.134 96.5L-415.134 101.696L-416 101.196L-413 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 96L-404.134 96.5L-407.134 101.696L-408 101.196L-405 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397 96L-396.134 96.5L-399.134 101.696L-400 101.196L-397 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389 96L-388.134 96.5L-391.134 101.696L-392 101.196L-389 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381 96L-380.134 96.5L-383.134 101.696L-384 101.196L-381 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373 96L-372.134 96.5L-375.134 101.696L-376 101.196L-373 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 96L-364.134 96.5L-367.134 101.696L-368 101.196L-365 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-357 96L-356.134 96.5L-359.134 101.696L-360 101.196L-357 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349 96L-348.134 96.5L-351.134 101.696L-352 101.196L-349 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341 96L-340.134 96.5L-343.134 101.696L-344 101.196L-341 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333 96L-332.134 96.5L-335.134 101.696L-336 101.196L-333 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 96L-324.134 96.5L-327.134 101.696L-328 101.196L-325 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317 96L-316.134 96.5L-319.134 101.696L-320 101.196L-317 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 96L-308.134 96.5L-311.134 101.696L-312 101.196L-309 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301 96L-300.134 96.5L-303.134 101.696L-304 101.196L-301 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293 96L-292.134 96.5L-295.134 101.696L-296 101.196L-293 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 96L-284.134 96.5L-287.134 101.696L-288 101.196L-285 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277 96L-276.134 96.5L-279.134 101.696L-280 101.196L-277 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269 96L-268.134 96.5L-271.134 101.696L-272 101.196L-269 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261 96L-260.134 96.5L-263.134 101.696L-264 101.196L-261 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253 96L-252.134 96.5L-255.134 101.696L-256 101.196L-253 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 96L-244.134 96.5L-247.134 101.696L-248 101.196L-245 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237 96L-236.134 96.5L-239.134 101.696L-240 101.196L-237 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229 96L-228.134 96.5L-231.134 101.696L-232 101.196L-229 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-221 96L-220.134 96.5L-223.134 101.696L-224 101.196L-221 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213 96L-212.134 96.5L-215.134 101.696L-216 101.196L-213 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 96L-204.134 96.5L-207.134 101.696L-208 101.196L-205 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-197 96L-196.134 96.5L-199.134 101.696L-200 101.196L-197 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189 96L-188.134 96.5L-191.134 101.696L-192 101.196L-189 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181 96L-180.134 96.5L-183.134 101.696L-184 101.196L-181 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173 96L-172.134 96.5L-175.134 101.696L-176 101.196L-173 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 96L-164.134 96.5L-167.134 101.696L-168 101.196L-165 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157 96L-156.134 96.5L-159.134 101.696L-160 101.196L-157 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149 96L-148.134 96.5L-151.134 101.696L-152 101.196L-149 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141 96L-140.134 96.5L-143.134 101.696L-144 101.196L-141 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 7.62939e-06L-132.134 0.500008L-135.134 5.69616L-136 5.19616L-133 7.62939e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 0L-124.134 0.5L-127.134 5.69615L-128 5.19615L-125 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 0L-116.134 0.5L-119.134 5.69615L-120 5.19615L-117 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 0L-108.134 0.5L-111.134 5.69615L-112 5.19615L-109 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 0L-100.134 0.5L-103.134 5.69615L-104 5.19615L-101 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 0L-92.134 0.5L-95.134 5.69615L-96 5.19615L-93 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 0L-84.134 0.5L-87.134 5.69615L-88 5.19615L-85 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 0L-76.134 0.5L-79.134 5.69615L-80 5.19615L-77 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 0L-68.134 0.5L-71.134 5.69615L-72 5.19615L-69 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 0L-60.134 0.5L-63.134 5.69615L-64 5.19615L-61 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 0L-52.134 0.5L-55.134 5.69615L-56 5.19615L-53 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 0L-44.134 0.5L-47.134 5.69615L-48 5.19615L-45 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 0L-36.134 0.5L-39.134 5.69615L-40 5.19615L-37 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 0L-28.134 0.5L-31.134 5.69615L-32 5.19615L-29 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 0L-20.134 0.5L-23.134 5.69615L-24 5.19615L-21 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 0L-12.134 0.5L-15.134 5.69615L-16 5.19615L-13 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 0L-4.13397 0.5L-7.13397 5.69615L-8 5.19615L-5 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0L3.86603 0.5L0.866028 5.69615L0 5.19615L3 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0L11.866 0.5L8.86603 5.69615L8 5.19615L11 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0L19.866 0.5L16.866 5.69615L16 5.19615L19 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 0L27.866 0.5L24.866 5.69615L24 5.19615L27 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0L35.866 0.5L32.866 5.69615L32 5.19615L35 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 0L43.866 0.5L40.866 5.69615L40 5.19615L43 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 0L51.866 0.5L48.866 5.69615L48 5.19615L51 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 0L59.866 0.5L56.866 5.69615L56 5.19615L59 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 0L67.866 0.5L64.866 5.69615L64 5.19615L67 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 0L75.866 0.5L72.866 5.69615L72 5.19615L75 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 0L83.866 0.5L80.866 5.69615L80 5.19615L83 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 0L91.866 0.5L88.866 5.69615L88 5.19615L91 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 0L99.866 0.5L96.866 5.69615L96 5.19615L99 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 0L107.866 0.5L104.866 5.69615L104 5.19615L107 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 0L115.866 0.5L112.866 5.69615L112 5.19615L115 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 0L123.866 0.5L120.866 5.69615L120 5.19615L123 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 0L131.866 0.5L128.866 5.69615L128 5.19615L131 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 0L139.866 0.5L136.866 5.69615L136 5.19615L139 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 0L147.866 0.5L144.866 5.69615L144 5.19615L147 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 0L155.866 0.5L152.866 5.69615L152 5.19615L155 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 0L163.866 0.5L160.866 5.69615L160 5.19615L163 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 0L171.866 0.5L168.866 5.69615L168 5.19615L171 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 0L179.866 0.5L176.866 5.69615L176 5.19615L179 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 0L187.866 0.5L184.866 5.69615L184 5.19615L187 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 0L195.866 0.5L192.866 5.69615L192 5.19615L195 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 0L203.866 0.5L200.866 5.69615L200 5.19615L203 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 0L211.866 0.5L208.866 5.69615L208 5.19615L211 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 0L219.866 0.5L216.866 5.69615L216 5.19615L219 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 0L227.866 0.5L224.866 5.69615L224 5.19615L227 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 0L235.866 0.5L232.866 5.69615L232 5.19615L235 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 0L243.866 0.5L240.866 5.69615L240 5.19615L243 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 0L251.866 0.5L248.866 5.69615L248 5.19615L251 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 0L259.866 0.5L256.866 5.69615L256 5.19615L259 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 0L267.866 0.5L264.866 5.69615L264 5.19615L267 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 0L275.866 0.5L272.866 5.69615L272 5.19615L275 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 0L283.866 0.5L280.866 5.69615L280 5.19615L283 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 8.00001L-132.134 8.50001L-135.134 13.6962L-136 13.1962L-133 8.00001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 8L-124.134 8.5L-127.134 13.6962L-128 13.1962L-125 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 8L-116.134 8.5L-119.134 13.6962L-120 13.1962L-117 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 8L-108.134 8.5L-111.134 13.6962L-112 13.1962L-109 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 8L-100.134 8.5L-103.134 13.6962L-104 13.1962L-101 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 8L-92.134 8.5L-95.134 13.6962L-96 13.1962L-93 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 8L-84.134 8.5L-87.134 13.6962L-88 13.1962L-85 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 8L-76.134 8.5L-79.134 13.6962L-80 13.1962L-77 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 8L-68.134 8.5L-71.134 13.6962L-72 13.1962L-69 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 8L-60.134 8.5L-63.134 13.6962L-64 13.1962L-61 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 8L-52.134 8.5L-55.134 13.6962L-56 13.1962L-53 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 8L-44.134 8.5L-47.134 13.6962L-48 13.1962L-45 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 8L-36.134 8.5L-39.134 13.6962L-40 13.1962L-37 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 8L-28.134 8.5L-31.134 13.6962L-32 13.1962L-29 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 8L-20.134 8.5L-23.134 13.6962L-24 13.1962L-21 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 8L-12.134 8.5L-15.134 13.6962L-16 13.1962L-13 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 8L-4.13397 8.5L-7.13397 13.6962L-8 13.1962L-5 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8L3.86603 8.5L0.866028 13.6962L0 13.1962L3 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8L11.866 8.5L8.86603 13.6962L8 13.1962L11 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8L19.866 8.5L16.866 13.6962L16 13.1962L19 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 8L27.866 8.5L24.866 13.6962L24 13.1962L27 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8L35.866 8.5L32.866 13.6962L32 13.1962L35 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 8L43.866 8.5L40.866 13.6962L40 13.1962L43 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 8L51.866 8.5L48.866 13.6962L48 13.1962L51 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 8L59.866 8.5L56.866 13.6962L56 13.1962L59 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 8L67.866 8.5L64.866 13.6962L64 13.1962L67 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 8L75.866 8.5L72.866 13.6962L72 13.1962L75 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 8L83.866 8.5L80.866 13.6962L80 13.1962L83 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 8L91.866 8.5L88.866 13.6962L88 13.1962L91 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 8L99.866 8.5L96.866 13.6962L96 13.1962L99 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 8L107.866 8.5L104.866 13.6962L104 13.1962L107 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 8L115.866 8.5L112.866 13.6962L112 13.1962L115 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 8L123.866 8.5L120.866 13.6962L120 13.1962L123 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 8L131.866 8.5L128.866 13.6962L128 13.1962L131 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 8L139.866 8.5L136.866 13.6962L136 13.1962L139 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 8L147.866 8.5L144.866 13.6962L144 13.1962L147 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 8L155.866 8.5L152.866 13.6962L152 13.1962L155 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 8L163.866 8.5L160.866 13.6962L160 13.1962L163 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 8L171.866 8.5L168.866 13.6962L168 13.1962L171 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 8L179.866 8.5L176.866 13.6962L176 13.1962L179 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 8L187.866 8.5L184.866 13.6962L184 13.1962L187 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 8L195.866 8.5L192.866 13.6962L192 13.1962L195 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 8L203.866 8.5L200.866 13.6962L200 13.1962L203 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 8L211.866 8.5L208.866 13.6962L208 13.1962L211 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 8L219.866 8.5L216.866 13.6962L216 13.1962L219 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 8L227.866 8.5L224.866 13.6962L224 13.1962L227 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 8L235.866 8.5L232.866 13.6962L232 13.1962L235 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 8L243.866 8.5L240.866 13.6962L240 13.1962L243 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 8L251.866 8.5L248.866 13.6962L248 13.1962L251 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 8L259.866 8.5L256.866 13.6962L256 13.1962L259 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 8L267.866 8.5L264.866 13.6962L264 13.1962L267 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 8L275.866 8.5L272.866 13.6962L272 13.1962L275 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 8L283.866 8.5L280.866 13.6962L280 13.1962L283 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 16L-132.134 16.5L-135.134 21.6962L-136 21.1962L-133 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 16L-124.134 16.5L-127.134 21.6962L-128 21.1962L-125 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 16L-116.134 16.5L-119.134 21.6962L-120 21.1962L-117 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 16L-108.134 16.5L-111.134 21.6962L-112 21.1962L-109 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 16L-100.134 16.5L-103.134 21.6962L-104 21.1962L-101 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 16L-92.134 16.5L-95.134 21.6962L-96 21.1962L-93 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 16L-84.134 16.5L-87.134 21.6962L-88 21.1962L-85 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 16L-76.134 16.5L-79.134 21.6962L-80 21.1962L-77 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 16L-68.134 16.5L-71.134 21.6962L-72 21.1962L-69 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 16L-60.134 16.5L-63.134 21.6962L-64 21.1962L-61 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 16L-52.134 16.5L-55.134 21.6962L-56 21.1962L-53 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 16L-44.134 16.5L-47.134 21.6962L-48 21.1962L-45 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 16L-36.134 16.5L-39.134 21.6962L-40 21.1962L-37 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 16L-28.134 16.5L-31.134 21.6962L-32 21.1962L-29 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 16L-20.134 16.5L-23.134 21.6962L-24 21.1962L-21 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 16L-12.134 16.5L-15.134 21.6962L-16 21.1962L-13 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 16L-4.13397 16.5L-7.13397 21.6962L-8 21.1962L-5 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16L3.86603 16.5L0.866028 21.6962L0 21.1962L3 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16L11.866 16.5L8.86603 21.6962L8 21.1962L11 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16L19.866 16.5L16.866 21.6962L16 21.1962L19 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16L27.866 16.5L24.866 21.6962L24 21.1962L27 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 16L35.866 16.5L32.866 21.6962L32 21.1962L35 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 16L43.866 16.5L40.866 21.6962L40 21.1962L43 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 16L51.866 16.5L48.866 21.6962L48 21.1962L51 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 16L59.866 16.5L56.866 21.6962L56 21.1962L59 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 16L67.866 16.5L64.866 21.6962L64 21.1962L67 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 16L75.866 16.5L72.866 21.6962L72 21.1962L75 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 16L83.866 16.5L80.866 21.6962L80 21.1962L83 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 16L91.866 16.5L88.866 21.6962L88 21.1962L91 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 16L99.866 16.5L96.866 21.6962L96 21.1962L99 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 16L107.866 16.5L104.866 21.6962L104 21.1962L107 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 16L115.866 16.5L112.866 21.6962L112 21.1962L115 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 16L123.866 16.5L120.866 21.6962L120 21.1962L123 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 16L131.866 16.5L128.866 21.6962L128 21.1962L131 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 16L139.866 16.5L136.866 21.6962L136 21.1962L139 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 16L147.866 16.5L144.866 21.6962L144 21.1962L147 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 16L155.866 16.5L152.866 21.6962L152 21.1962L155 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 16L163.866 16.5L160.866 21.6962L160 21.1962L163 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 16L171.866 16.5L168.866 21.6962L168 21.1962L171 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 16L179.866 16.5L176.866 21.6962L176 21.1962L179 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 16L187.866 16.5L184.866 21.6962L184 21.1962L187 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 16L195.866 16.5L192.866 21.6962L192 21.1962L195 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 16L203.866 16.5L200.866 21.6962L200 21.1962L203 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 16L211.866 16.5L208.866 21.6962L208 21.1962L211 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 16L219.866 16.5L216.866 21.6962L216 21.1962L219 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 16L227.866 16.5L224.866 21.6962L224 21.1962L227 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 16L235.866 16.5L232.866 21.6962L232 21.1962L235 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 16L243.866 16.5L240.866 21.6962L240 21.1962L243 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 16L251.866 16.5L248.866 21.6962L248 21.1962L251 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 16L259.866 16.5L256.866 21.6962L256 21.1962L259 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 16L267.866 16.5L264.866 21.6962L264 21.1962L267 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 16L275.866 16.5L272.866 21.6962L272 21.1962L275 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 16L283.866 16.5L280.866 21.6962L280 21.1962L283 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 24L-132.134 24.5L-135.134 29.6962L-136 29.1962L-133 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 24L-124.134 24.5L-127.134 29.6962L-128 29.1962L-125 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 24L-116.134 24.5L-119.134 29.6962L-120 29.1962L-117 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 24L-108.134 24.5L-111.134 29.6962L-112 29.1962L-109 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 24L-100.134 24.5L-103.134 29.6962L-104 29.1962L-101 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 24L-92.134 24.5L-95.134 29.6962L-96 29.1962L-93 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 24L-84.134 24.5L-87.134 29.6962L-88 29.1962L-85 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 24L-76.134 24.5L-79.134 29.6962L-80 29.1962L-77 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 24L-68.134 24.5L-71.134 29.6962L-72 29.1962L-69 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 24L-60.134 24.5L-63.134 29.6962L-64 29.1962L-61 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 24L-52.134 24.5L-55.134 29.6962L-56 29.1962L-53 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 24L-44.134 24.5L-47.134 29.6962L-48 29.1962L-45 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 24L-36.134 24.5L-39.134 29.6962L-40 29.1962L-37 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 24L-28.134 24.5L-31.134 29.6962L-32 29.1962L-29 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 24L-20.134 24.5L-23.134 29.6962L-24 29.1962L-21 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 24L-12.134 24.5L-15.134 29.6962L-16 29.1962L-13 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 24L-4.13397 24.5L-7.13397 29.6962L-8 29.1962L-5 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 24L3.86603 24.5L0.866028 29.6962L0 29.1962L3 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 24L11.866 24.5L8.86603 29.6962L8 29.1962L11 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 24L19.866 24.5L16.866 29.6962L16 29.1962L19 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 24L27.866 24.5L24.866 29.6962L24 29.1962L27 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 24L35.866 24.5L32.866 29.6962L32 29.1962L35 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 24L43.866 24.5L40.866 29.6962L40 29.1962L43 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 24L51.866 24.5L48.866 29.6962L48 29.1962L51 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 24L59.866 24.5L56.866 29.6962L56 29.1962L59 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 24L67.866 24.5L64.866 29.6962L64 29.1962L67 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 24L75.866 24.5L72.866 29.6962L72 29.1962L75 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 24L83.866 24.5L80.866 29.6962L80 29.1962L83 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 24L91.866 24.5L88.866 29.6962L88 29.1962L91 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 24L99.866 24.5L96.866 29.6962L96 29.1962L99 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 24L107.866 24.5L104.866 29.6962L104 29.1962L107 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 24L115.866 24.5L112.866 29.6962L112 29.1962L115 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 24L123.866 24.5L120.866 29.6962L120 29.1962L123 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 24L131.866 24.5L128.866 29.6962L128 29.1962L131 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 24L139.866 24.5L136.866 29.6962L136 29.1962L139 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 24L147.866 24.5L144.866 29.6962L144 29.1962L147 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 24L155.866 24.5L152.866 29.6962L152 29.1962L155 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 24L163.866 24.5L160.866 29.6962L160 29.1962L163 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 24L171.866 24.5L168.866 29.6962L168 29.1962L171 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 24L179.866 24.5L176.866 29.6962L176 29.1962L179 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 24L187.866 24.5L184.866 29.6962L184 29.1962L187 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 24L195.866 24.5L192.866 29.6962L192 29.1962L195 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 24L203.866 24.5L200.866 29.6962L200 29.1962L203 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 24L211.866 24.5L208.866 29.6962L208 29.1962L211 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 24L219.866 24.5L216.866 29.6962L216 29.1962L219 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 24L227.866 24.5L224.866 29.6962L224 29.1962L227 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 24L235.866 24.5L232.866 29.6962L232 29.1962L235 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 24L243.866 24.5L240.866 29.6962L240 29.1962L243 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 24L251.866 24.5L248.866 29.6962L248 29.1962L251 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 24L259.866 24.5L256.866 29.6962L256 29.1962L259 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 24L267.866 24.5L264.866 29.6962L264 29.1962L267 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 24L275.866 24.5L272.866 29.6962L272 29.1962L275 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 24L283.866 24.5L280.866 29.6962L280 29.1962L283 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 32L-132.134 32.5L-135.134 37.6962L-136 37.1962L-133 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 32L-124.134 32.5L-127.134 37.6962L-128 37.1962L-125 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 32L-116.134 32.5L-119.134 37.6962L-120 37.1962L-117 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 32L-108.134 32.5L-111.134 37.6962L-112 37.1962L-109 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 32L-100.134 32.5L-103.134 37.6962L-104 37.1962L-101 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 32L-92.134 32.5L-95.134 37.6962L-96 37.1962L-93 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 32L-84.134 32.5L-87.134 37.6962L-88 37.1962L-85 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 32L-76.134 32.5L-79.134 37.6962L-80 37.1962L-77 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 32L-68.134 32.5L-71.134 37.6962L-72 37.1962L-69 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 32L-60.134 32.5L-63.134 37.6962L-64 37.1962L-61 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 32L-52.134 32.5L-55.134 37.6962L-56 37.1962L-53 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 32L-44.134 32.5L-47.134 37.6962L-48 37.1962L-45 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 32L-36.134 32.5L-39.134 37.6962L-40 37.1962L-37 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 32L-28.134 32.5L-31.134 37.6962L-32 37.1962L-29 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 32L-20.134 32.5L-23.134 37.6962L-24 37.1962L-21 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 32L-12.134 32.5L-15.134 37.6962L-16 37.1962L-13 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 32L-4.13397 32.5L-7.13397 37.6962L-8 37.1962L-5 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 32L3.86603 32.5L0.866028 37.6962L0 37.1962L3 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32L11.866 32.5L8.86603 37.6962L8 37.1962L11 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 32L19.866 32.5L16.866 37.6962L16 37.1962L19 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 32L27.866 32.5L24.866 37.6962L24 37.1962L27 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 32L35.866 32.5L32.866 37.6962L32 37.1962L35 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 32L43.866 32.5L40.866 37.6962L40 37.1962L43 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 32L51.866 32.5L48.866 37.6962L48 37.1962L51 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 32L59.866 32.5L56.866 37.6962L56 37.1962L59 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32L67.866 32.5L64.866 37.6962L64 37.1962L67 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 32L75.866 32.5L72.866 37.6962L72 37.1962L75 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 32L83.866 32.5L80.866 37.6962L80 37.1962L83 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 32L91.866 32.5L88.866 37.6962L88 37.1962L91 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 32L99.866 32.5L96.866 37.6962L96 37.1962L99 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 32L107.866 32.5L104.866 37.6962L104 37.1962L107 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 32L115.866 32.5L112.866 37.6962L112 37.1962L115 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 32L123.866 32.5L120.866 37.6962L120 37.1962L123 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 32L131.866 32.5L128.866 37.6962L128 37.1962L131 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 32L139.866 32.5L136.866 37.6962L136 37.1962L139 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 32L147.866 32.5L144.866 37.6962L144 37.1962L147 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 32L155.866 32.5L152.866 37.6962L152 37.1962L155 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 32L163.866 32.5L160.866 37.6962L160 37.1962L163 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 32L171.866 32.5L168.866 37.6962L168 37.1962L171 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 32L179.866 32.5L176.866 37.6962L176 37.1962L179 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 32L187.866 32.5L184.866 37.6962L184 37.1962L187 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 32L195.866 32.5L192.866 37.6962L192 37.1962L195 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 32L203.866 32.5L200.866 37.6962L200 37.1962L203 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 32L211.866 32.5L208.866 37.6962L208 37.1962L211 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 32L219.866 32.5L216.866 37.6962L216 37.1962L219 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 32L227.866 32.5L224.866 37.6962L224 37.1962L227 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 32L235.866 32.5L232.866 37.6962L232 37.1962L235 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 32L243.866 32.5L240.866 37.6962L240 37.1962L243 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 32L251.866 32.5L248.866 37.6962L248 37.1962L251 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 32L259.866 32.5L256.866 37.6962L256 37.1962L259 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 32L267.866 32.5L264.866 37.6962L264 37.1962L267 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 32L275.866 32.5L272.866 37.6962L272 37.1962L275 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 32L283.866 32.5L280.866 37.6962L280 37.1962L283 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 40L-132.134 40.5L-135.134 45.6962L-136 45.1962L-133 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 40L-124.134 40.5L-127.134 45.6962L-128 45.1962L-125 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 40L-116.134 40.5L-119.134 45.6962L-120 45.1962L-117 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 40L-108.134 40.5L-111.134 45.6962L-112 45.1962L-109 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 40L-100.134 40.5L-103.134 45.6962L-104 45.1962L-101 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 40L-92.134 40.5L-95.134 45.6962L-96 45.1962L-93 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 40L-84.134 40.5L-87.134 45.6962L-88 45.1962L-85 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 40L-76.134 40.5L-79.134 45.6962L-80 45.1962L-77 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 40L-68.134 40.5L-71.134 45.6962L-72 45.1962L-69 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 40L-60.134 40.5L-63.134 45.6962L-64 45.1962L-61 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 40L-52.134 40.5L-55.134 45.6962L-56 45.1962L-53 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 40L-44.134 40.5L-47.134 45.6962L-48 45.1962L-45 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 40L-36.134 40.5L-39.134 45.6962L-40 45.1962L-37 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 40L-28.134 40.5L-31.134 45.6962L-32 45.1962L-29 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 40L-20.134 40.5L-23.134 45.6962L-24 45.1962L-21 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 40L-12.134 40.5L-15.134 45.6962L-16 45.1962L-13 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 40L-4.13397 40.5L-7.13397 45.6962L-8 45.1962L-5 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 40L3.86603 40.5L0.866028 45.6962L0 45.1962L3 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 40L11.866 40.5L8.86603 45.6962L8 45.1962L11 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 40L19.866 40.5L16.866 45.6962L16 45.1962L19 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 40L27.866 40.5L24.866 45.6962L24 45.1962L27 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 40L35.866 40.5L32.866 45.6962L32 45.1962L35 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 40L43.866 40.5L40.866 45.6962L40 45.1962L43 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 40L51.866 40.5L48.866 45.6962L48 45.1962L51 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 40L59.866 40.5L56.866 45.6962L56 45.1962L59 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 40L67.866 40.5L64.866 45.6962L64 45.1962L67 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 40L75.866 40.5L72.866 45.6962L72 45.1962L75 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 40L83.866 40.5L80.866 45.6962L80 45.1962L83 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 40L91.866 40.5L88.866 45.6962L88 45.1962L91 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 40L99.866 40.5L96.866 45.6962L96 45.1962L99 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 40L107.866 40.5L104.866 45.6962L104 45.1962L107 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 40L115.866 40.5L112.866 45.6962L112 45.1962L115 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 40L123.866 40.5L120.866 45.6962L120 45.1962L123 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 40L131.866 40.5L128.866 45.6962L128 45.1962L131 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 40L139.866 40.5L136.866 45.6962L136 45.1962L139 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 40L147.866 40.5L144.866 45.6962L144 45.1962L147 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 40L155.866 40.5L152.866 45.6962L152 45.1962L155 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 40L163.866 40.5L160.866 45.6962L160 45.1962L163 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 40L171.866 40.5L168.866 45.6962L168 45.1962L171 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 40L179.866 40.5L176.866 45.6962L176 45.1962L179 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 40L187.866 40.5L184.866 45.6962L184 45.1962L187 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 40L195.866 40.5L192.866 45.6962L192 45.1962L195 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 40L203.866 40.5L200.866 45.6962L200 45.1962L203 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 40L211.866 40.5L208.866 45.6962L208 45.1962L211 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 40L219.866 40.5L216.866 45.6962L216 45.1962L219 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 40L227.866 40.5L224.866 45.6962L224 45.1962L227 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 40L235.866 40.5L232.866 45.6962L232 45.1962L235 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 40L243.866 40.5L240.866 45.6962L240 45.1962L243 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 40L251.866 40.5L248.866 45.6962L248 45.1962L251 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 40L259.866 40.5L256.866 45.6962L256 45.1962L259 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 40L267.866 40.5L264.866 45.6962L264 45.1962L267 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 40L275.866 40.5L272.866 45.6962L272 45.1962L275 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 40L283.866 40.5L280.866 45.6962L280 45.1962L283 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 48L-132.134 48.5L-135.134 53.6962L-136 53.1962L-133 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 48L-124.134 48.5L-127.134 53.6962L-128 53.1962L-125 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 48L-116.134 48.5L-119.134 53.6962L-120 53.1962L-117 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 48L-108.134 48.5L-111.134 53.6962L-112 53.1962L-109 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 48L-100.134 48.5L-103.134 53.6962L-104 53.1962L-101 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 48L-92.134 48.5L-95.134 53.6962L-96 53.1962L-93 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 48L-84.134 48.5L-87.134 53.6962L-88 53.1962L-85 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 48L-76.134 48.5L-79.134 53.6962L-80 53.1962L-77 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 48L-68.134 48.5L-71.134 53.6962L-72 53.1962L-69 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 48L-60.134 48.5L-63.134 53.6962L-64 53.1962L-61 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 48L-52.134 48.5L-55.134 53.6962L-56 53.1962L-53 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 48L-44.134 48.5L-47.134 53.6962L-48 53.1962L-45 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 48L-36.134 48.5L-39.134 53.6962L-40 53.1962L-37 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 48L-28.134 48.5L-31.134 53.6962L-32 53.1962L-29 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 48L-20.134 48.5L-23.134 53.6962L-24 53.1962L-21 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 48L-12.134 48.5L-15.134 53.6962L-16 53.1962L-13 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 48L-4.13397 48.5L-7.13397 53.6962L-8 53.1962L-5 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 48L3.86603 48.5L0.866028 53.6962L0 53.1962L3 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 48L11.866 48.5L8.86603 53.6962L8 53.1962L11 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 48L19.866 48.5L16.866 53.6962L16 53.1962L19 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 48L27.866 48.5L24.866 53.6962L24 53.1962L27 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 48L35.866 48.5L32.866 53.6962L32 53.1962L35 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 48L43.866 48.5L40.866 53.6962L40 53.1962L43 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 48L51.866 48.5L48.866 53.6962L48 53.1962L51 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 48L59.866 48.5L56.866 53.6962L56 53.1962L59 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 48L67.866 48.5L64.866 53.6962L64 53.1962L67 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 48L75.866 48.5L72.866 53.6962L72 53.1962L75 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 48L83.866 48.5L80.866 53.6962L80 53.1962L83 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 48L91.866 48.5L88.866 53.6962L88 53.1962L91 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 48L99.866 48.5L96.866 53.6962L96 53.1962L99 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 48L107.866 48.5L104.866 53.6962L104 53.1962L107 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 48L115.866 48.5L112.866 53.6962L112 53.1962L115 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 48L123.866 48.5L120.866 53.6962L120 53.1962L123 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 48L131.866 48.5L128.866 53.6962L128 53.1962L131 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 48L139.866 48.5L136.866 53.6962L136 53.1962L139 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 48L147.866 48.5L144.866 53.6962L144 53.1962L147 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 48L155.866 48.5L152.866 53.6962L152 53.1962L155 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 48L163.866 48.5L160.866 53.6962L160 53.1962L163 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 48L171.866 48.5L168.866 53.6962L168 53.1962L171 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 48L179.866 48.5L176.866 53.6962L176 53.1962L179 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 48L187.866 48.5L184.866 53.6962L184 53.1962L187 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 48L195.866 48.5L192.866 53.6962L192 53.1962L195 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 48L203.866 48.5L200.866 53.6962L200 53.1962L203 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 48L211.866 48.5L208.866 53.6962L208 53.1962L211 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 48L219.866 48.5L216.866 53.6962L216 53.1962L219 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 48L227.866 48.5L224.866 53.6962L224 53.1962L227 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 48L235.866 48.5L232.866 53.6962L232 53.1962L235 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 48L243.866 48.5L240.866 53.6962L240 53.1962L243 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 48L251.866 48.5L248.866 53.6962L248 53.1962L251 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 48L259.866 48.5L256.866 53.6962L256 53.1962L259 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 48L267.866 48.5L264.866 53.6962L264 53.1962L267 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 48L275.866 48.5L272.866 53.6962L272 53.1962L275 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 48L283.866 48.5L280.866 53.6962L280 53.1962L283 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 56L-132.134 56.5L-135.134 61.6962L-136 61.1962L-133 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 56L-124.134 56.5L-127.134 61.6962L-128 61.1962L-125 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 56L-116.134 56.5L-119.134 61.6962L-120 61.1962L-117 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 56L-108.134 56.5L-111.134 61.6962L-112 61.1962L-109 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 56L-100.134 56.5L-103.134 61.6962L-104 61.1962L-101 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 56L-92.134 56.5L-95.134 61.6962L-96 61.1962L-93 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 56L-84.134 56.5L-87.134 61.6962L-88 61.1962L-85 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 56L-76.134 56.5L-79.134 61.6962L-80 61.1962L-77 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 56L-68.134 56.5L-71.134 61.6962L-72 61.1962L-69 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 56L-60.134 56.5L-63.134 61.6962L-64 61.1962L-61 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 56L-52.134 56.5L-55.134 61.6962L-56 61.1962L-53 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 56L-44.134 56.5L-47.134 61.6962L-48 61.1962L-45 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 56L-36.134 56.5L-39.134 61.6962L-40 61.1962L-37 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 56L-28.134 56.5L-31.134 61.6962L-32 61.1962L-29 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 56L-20.134 56.5L-23.134 61.6962L-24 61.1962L-21 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 56L-12.134 56.5L-15.134 61.6962L-16 61.1962L-13 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 56L-4.13397 56.5L-7.13397 61.6962L-8 61.1962L-5 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 56L3.86603 56.5L0.866028 61.6962L0 61.1962L3 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 56L11.866 56.5L8.86603 61.6962L8 61.1962L11 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 56L19.866 56.5L16.866 61.6962L16 61.1962L19 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 56L27.866 56.5L24.866 61.6962L24 61.1962L27 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 56L35.866 56.5L32.866 61.6962L32 61.1962L35 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 56L43.866 56.5L40.866 61.6962L40 61.1962L43 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 56L51.866 56.5L48.866 61.6962L48 61.1962L51 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 56L59.866 56.5L56.866 61.6962L56 61.1962L59 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 56L67.866 56.5L64.866 61.6962L64 61.1962L67 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 56L75.866 56.5L72.866 61.6962L72 61.1962L75 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 56L83.866 56.5L80.866 61.6962L80 61.1962L83 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 56L91.866 56.5L88.866 61.6962L88 61.1962L91 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 56L99.866 56.5L96.866 61.6962L96 61.1962L99 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 56L107.866 56.5L104.866 61.6962L104 61.1962L107 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 56L115.866 56.5L112.866 61.6962L112 61.1962L115 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 56L123.866 56.5L120.866 61.6962L120 61.1962L123 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 56L131.866 56.5L128.866 61.6962L128 61.1962L131 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 56L139.866 56.5L136.866 61.6962L136 61.1962L139 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 56L147.866 56.5L144.866 61.6962L144 61.1962L147 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 56L155.866 56.5L152.866 61.6962L152 61.1962L155 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 56L163.866 56.5L160.866 61.6962L160 61.1962L163 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 56L171.866 56.5L168.866 61.6962L168 61.1962L171 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 56L179.866 56.5L176.866 61.6962L176 61.1962L179 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 56L187.866 56.5L184.866 61.6962L184 61.1962L187 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 56L195.866 56.5L192.866 61.6962L192 61.1962L195 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 56L203.866 56.5L200.866 61.6962L200 61.1962L203 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 56L211.866 56.5L208.866 61.6962L208 61.1962L211 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 56L219.866 56.5L216.866 61.6962L216 61.1962L219 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 56L227.866 56.5L224.866 61.6962L224 61.1962L227 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 56L235.866 56.5L232.866 61.6962L232 61.1962L235 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 56L243.866 56.5L240.866 61.6962L240 61.1962L243 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 56L251.866 56.5L248.866 61.6962L248 61.1962L251 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 56L259.866 56.5L256.866 61.6962L256 61.1962L259 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 56L267.866 56.5L264.866 61.6962L264 61.1962L267 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 56L275.866 56.5L272.866 61.6962L272 61.1962L275 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 56L283.866 56.5L280.866 61.6962L280 61.1962L283 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 64L-132.134 64.5L-135.134 69.6962L-136 69.1962L-133 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 64L-124.134 64.5L-127.134 69.6962L-128 69.1962L-125 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 64L-116.134 64.5L-119.134 69.6962L-120 69.1962L-117 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 64L-108.134 64.5L-111.134 69.6962L-112 69.1962L-109 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 64L-100.134 64.5L-103.134 69.6962L-104 69.1962L-101 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 64L-92.134 64.5L-95.134 69.6962L-96 69.1962L-93 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 64L-84.134 64.5L-87.134 69.6962L-88 69.1962L-85 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 64L-76.134 64.5L-79.134 69.6962L-80 69.1962L-77 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 64L-68.134 64.5L-71.134 69.6962L-72 69.1962L-69 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 64L-60.134 64.5L-63.134 69.6962L-64 69.1962L-61 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 64L-52.134 64.5L-55.134 69.6962L-56 69.1962L-53 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 64L-44.134 64.5L-47.134 69.6962L-48 69.1962L-45 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 64L-36.134 64.5L-39.134 69.6962L-40 69.1962L-37 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 64L-28.134 64.5L-31.134 69.6962L-32 69.1962L-29 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 64L-20.134 64.5L-23.134 69.6962L-24 69.1962L-21 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 64L-12.134 64.5L-15.134 69.6962L-16 69.1962L-13 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 64L-4.13397 64.5L-7.13397 69.6962L-8 69.1962L-5 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 64L3.86603 64.5L0.866028 69.6962L0 69.1962L3 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 64L11.866 64.5L8.86603 69.6962L8 69.1962L11 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 64L19.866 64.5L16.866 69.6962L16 69.1962L19 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 64L27.866 64.5L24.866 69.6962L24 69.1962L27 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 64L35.866 64.5L32.866 69.6962L32 69.1962L35 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 64L43.866 64.5L40.866 69.6962L40 69.1962L43 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 64L51.866 64.5L48.866 69.6962L48 69.1962L51 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 64L59.866 64.5L56.866 69.6962L56 69.1962L59 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 64L67.866 64.5L64.866 69.6962L64 69.1962L67 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 64L75.866 64.5L72.866 69.6962L72 69.1962L75 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 64L83.866 64.5L80.866 69.6962L80 69.1962L83 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 64L91.866 64.5L88.866 69.6962L88 69.1962L91 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 64L99.866 64.5L96.866 69.6962L96 69.1962L99 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 64L107.866 64.5L104.866 69.6962L104 69.1962L107 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 64L115.866 64.5L112.866 69.6962L112 69.1962L115 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 64L123.866 64.5L120.866 69.6962L120 69.1962L123 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 64L131.866 64.5L128.866 69.6962L128 69.1962L131 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 64L139.866 64.5L136.866 69.6962L136 69.1962L139 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 64L147.866 64.5L144.866 69.6962L144 69.1962L147 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 64L155.866 64.5L152.866 69.6962L152 69.1962L155 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 64L163.866 64.5L160.866 69.6962L160 69.1962L163 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 64L171.866 64.5L168.866 69.6962L168 69.1962L171 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 64L179.866 64.5L176.866 69.6962L176 69.1962L179 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 64L187.866 64.5L184.866 69.6962L184 69.1962L187 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 64L195.866 64.5L192.866 69.6962L192 69.1962L195 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 64L203.866 64.5L200.866 69.6962L200 69.1962L203 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 64L211.866 64.5L208.866 69.6962L208 69.1962L211 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 64L219.866 64.5L216.866 69.6962L216 69.1962L219 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 64L227.866 64.5L224.866 69.6962L224 69.1962L227 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 64L235.866 64.5L232.866 69.6962L232 69.1962L235 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 64L243.866 64.5L240.866 69.6962L240 69.1962L243 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 64L251.866 64.5L248.866 69.6962L248 69.1962L251 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 64L259.866 64.5L256.866 69.6962L256 69.1962L259 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 64L267.866 64.5L264.866 69.6962L264 69.1962L267 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 64L275.866 64.5L272.866 69.6962L272 69.1962L275 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 64L283.866 64.5L280.866 69.6962L280 69.1962L283 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 72L-132.134 72.5L-135.134 77.6962L-136 77.1962L-133 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 72L-124.134 72.5L-127.134 77.6962L-128 77.1962L-125 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 72L-116.134 72.5L-119.134 77.6962L-120 77.1962L-117 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 72L-108.134 72.5L-111.134 77.6962L-112 77.1962L-109 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 72L-100.134 72.5L-103.134 77.6962L-104 77.1962L-101 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 72L-92.134 72.5L-95.134 77.6962L-96 77.1962L-93 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 72L-84.134 72.5L-87.134 77.6962L-88 77.1962L-85 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 72L-76.134 72.5L-79.134 77.6962L-80 77.1962L-77 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 72L-68.134 72.5L-71.134 77.6962L-72 77.1962L-69 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 72L-60.134 72.5L-63.134 77.6962L-64 77.1962L-61 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 72L-52.134 72.5L-55.134 77.6962L-56 77.1962L-53 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 72L-44.134 72.5L-47.134 77.6962L-48 77.1962L-45 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 72L-36.134 72.5L-39.134 77.6962L-40 77.1962L-37 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 72L-28.134 72.5L-31.134 77.6962L-32 77.1962L-29 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 72L-20.134 72.5L-23.134 77.6962L-24 77.1962L-21 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 72L-12.134 72.5L-15.134 77.6962L-16 77.1962L-13 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 72L-4.13397 72.5L-7.13397 77.6962L-8 77.1962L-5 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 72L3.86603 72.5L0.866028 77.6962L0 77.1962L3 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 72L11.866 72.5L8.86603 77.6962L8 77.1962L11 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 72L19.866 72.5L16.866 77.6962L16 77.1962L19 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 72L27.866 72.5L24.866 77.6962L24 77.1962L27 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 72L35.866 72.5L32.866 77.6962L32 77.1962L35 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 72L43.866 72.5L40.866 77.6962L40 77.1962L43 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 72L51.866 72.5L48.866 77.6962L48 77.1962L51 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 72L59.866 72.5L56.866 77.6962L56 77.1962L59 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 72L67.866 72.5L64.866 77.6962L64 77.1962L67 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 72L75.866 72.5L72.866 77.6962L72 77.1962L75 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 72L83.866 72.5L80.866 77.6962L80 77.1962L83 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 72L91.866 72.5L88.866 77.6962L88 77.1962L91 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 72L99.866 72.5L96.866 77.6962L96 77.1962L99 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 72L107.866 72.5L104.866 77.6962L104 77.1962L107 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 72L115.866 72.5L112.866 77.6962L112 77.1962L115 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 72L123.866 72.5L120.866 77.6962L120 77.1962L123 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 72L131.866 72.5L128.866 77.6962L128 77.1962L131 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 72L139.866 72.5L136.866 77.6962L136 77.1962L139 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 72L147.866 72.5L144.866 77.6962L144 77.1962L147 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 72L155.866 72.5L152.866 77.6962L152 77.1962L155 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 72L163.866 72.5L160.866 77.6962L160 77.1962L163 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 72L171.866 72.5L168.866 77.6962L168 77.1962L171 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 72L179.866 72.5L176.866 77.6962L176 77.1962L179 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 72L187.866 72.5L184.866 77.6962L184 77.1962L187 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 72L195.866 72.5L192.866 77.6962L192 77.1962L195 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 72L203.866 72.5L200.866 77.6962L200 77.1962L203 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 72L211.866 72.5L208.866 77.6962L208 77.1962L211 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 72L219.866 72.5L216.866 77.6962L216 77.1962L219 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 72L227.866 72.5L224.866 77.6962L224 77.1962L227 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 72L235.866 72.5L232.866 77.6962L232 77.1962L235 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 72L243.866 72.5L240.866 77.6962L240 77.1962L243 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 72L251.866 72.5L248.866 77.6962L248 77.1962L251 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 72L259.866 72.5L256.866 77.6962L256 77.1962L259 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 72L267.866 72.5L264.866 77.6962L264 77.1962L267 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 72L275.866 72.5L272.866 77.6962L272 77.1962L275 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 72L283.866 72.5L280.866 77.6962L280 77.1962L283 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 80L-132.134 80.5L-135.134 85.6962L-136 85.1962L-133 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 80L-124.134 80.5L-127.134 85.6962L-128 85.1962L-125 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 80L-116.134 80.5L-119.134 85.6962L-120 85.1962L-117 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 80L-108.134 80.5L-111.134 85.6962L-112 85.1962L-109 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 80L-100.134 80.5L-103.134 85.6962L-104 85.1962L-101 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 80L-92.134 80.5L-95.134 85.6962L-96 85.1962L-93 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 80L-84.134 80.5L-87.134 85.6962L-88 85.1962L-85 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 80L-76.134 80.5L-79.134 85.6962L-80 85.1962L-77 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 80L-68.134 80.5L-71.134 85.6962L-72 85.1962L-69 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 80L-60.134 80.5L-63.134 85.6962L-64 85.1962L-61 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 80L-52.134 80.5L-55.134 85.6962L-56 85.1962L-53 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 80L-44.134 80.5L-47.134 85.6962L-48 85.1962L-45 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 80L-36.134 80.5L-39.134 85.6962L-40 85.1962L-37 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 80L-28.134 80.5L-31.134 85.6962L-32 85.1962L-29 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 80L-20.134 80.5L-23.134 85.6962L-24 85.1962L-21 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 80L-12.134 80.5L-15.134 85.6962L-16 85.1962L-13 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 80L-4.13397 80.5L-7.13397 85.6962L-8 85.1962L-5 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 80L3.86603 80.5L0.866028 85.6962L0 85.1962L3 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 80L11.866 80.5L8.86603 85.6962L8 85.1962L11 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 80L19.866 80.5L16.866 85.6962L16 85.1962L19 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 80L27.866 80.5L24.866 85.6962L24 85.1962L27 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 80L35.866 80.5L32.866 85.6962L32 85.1962L35 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 80L43.866 80.5L40.866 85.6962L40 85.1962L43 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 80L51.866 80.5L48.866 85.6962L48 85.1962L51 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 80L59.866 80.5L56.866 85.6962L56 85.1962L59 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 80L67.866 80.5L64.866 85.6962L64 85.1962L67 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 80L75.866 80.5L72.866 85.6962L72 85.1962L75 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 80L83.866 80.5L80.866 85.6962L80 85.1962L83 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 80L91.866 80.5L88.866 85.6962L88 85.1962L91 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 80L99.866 80.5L96.866 85.6962L96 85.1962L99 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 80L107.866 80.5L104.866 85.6962L104 85.1962L107 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 80L115.866 80.5L112.866 85.6962L112 85.1962L115 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 80L123.866 80.5L120.866 85.6962L120 85.1962L123 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 80L131.866 80.5L128.866 85.6962L128 85.1962L131 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 80L139.866 80.5L136.866 85.6962L136 85.1962L139 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 80L147.866 80.5L144.866 85.6962L144 85.1962L147 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 80L155.866 80.5L152.866 85.6962L152 85.1962L155 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 80L163.866 80.5L160.866 85.6962L160 85.1962L163 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 80L171.866 80.5L168.866 85.6962L168 85.1962L171 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 80L179.866 80.5L176.866 85.6962L176 85.1962L179 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 80L187.866 80.5L184.866 85.6962L184 85.1962L187 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 80L195.866 80.5L192.866 85.6962L192 85.1962L195 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 80L203.866 80.5L200.866 85.6962L200 85.1962L203 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 80L211.866 80.5L208.866 85.6962L208 85.1962L211 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 80L219.866 80.5L216.866 85.6962L216 85.1962L219 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 80L227.866 80.5L224.866 85.6962L224 85.1962L227 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 80L235.866 80.5L232.866 85.6962L232 85.1962L235 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 80L243.866 80.5L240.866 85.6962L240 85.1962L243 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 80L251.866 80.5L248.866 85.6962L248 85.1962L251 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 80L259.866 80.5L256.866 85.6962L256 85.1962L259 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 80L267.866 80.5L264.866 85.6962L264 85.1962L267 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 80L275.866 80.5L272.866 85.6962L272 85.1962L275 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 80L283.866 80.5L280.866 85.6962L280 85.1962L283 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 88L-132.134 88.5L-135.134 93.6962L-136 93.1962L-133 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 88L-124.134 88.5L-127.134 93.6962L-128 93.1962L-125 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 88L-116.134 88.5L-119.134 93.6962L-120 93.1962L-117 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 88L-108.134 88.5L-111.134 93.6962L-112 93.1962L-109 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 88L-100.134 88.5L-103.134 93.6962L-104 93.1962L-101 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 88L-92.134 88.5L-95.134 93.6962L-96 93.1962L-93 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 88L-84.134 88.5L-87.134 93.6962L-88 93.1962L-85 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 88L-76.134 88.5L-79.134 93.6962L-80 93.1962L-77 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 88L-68.134 88.5L-71.134 93.6962L-72 93.1962L-69 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 88L-60.134 88.5L-63.134 93.6962L-64 93.1962L-61 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 88L-52.134 88.5L-55.134 93.6962L-56 93.1962L-53 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 88L-44.134 88.5L-47.134 93.6962L-48 93.1962L-45 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 88L-36.134 88.5L-39.134 93.6962L-40 93.1962L-37 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 88L-28.134 88.5L-31.134 93.6962L-32 93.1962L-29 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 88L-20.134 88.5L-23.134 93.6962L-24 93.1962L-21 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 88L-12.134 88.5L-15.134 93.6962L-16 93.1962L-13 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 88L-4.13397 88.5L-7.13397 93.6962L-8 93.1962L-5 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 88L3.86603 88.5L0.866028 93.6962L0 93.1962L3 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 88L11.866 88.5L8.86603 93.6962L8 93.1962L11 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 88L19.866 88.5L16.866 93.6962L16 93.1962L19 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 88L27.866 88.5L24.866 93.6962L24 93.1962L27 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 88L35.866 88.5L32.866 93.6962L32 93.1962L35 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 88L43.866 88.5L40.866 93.6962L40 93.1962L43 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 88L51.866 88.5L48.866 93.6962L48 93.1962L51 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 88L59.866 88.5L56.866 93.6962L56 93.1962L59 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 88L67.866 88.5L64.866 93.6962L64 93.1962L67 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 88L75.866 88.5L72.866 93.6962L72 93.1962L75 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 88L83.866 88.5L80.866 93.6962L80 93.1962L83 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 88L91.866 88.5L88.866 93.6962L88 93.1962L91 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 88L99.866 88.5L96.866 93.6962L96 93.1962L99 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 88L107.866 88.5L104.866 93.6962L104 93.1962L107 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 88L115.866 88.5L112.866 93.6962L112 93.1962L115 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 88L123.866 88.5L120.866 93.6962L120 93.1962L123 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 88L131.866 88.5L128.866 93.6962L128 93.1962L131 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 88L139.866 88.5L136.866 93.6962L136 93.1962L139 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 88L147.866 88.5L144.866 93.6962L144 93.1962L147 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 88L155.866 88.5L152.866 93.6962L152 93.1962L155 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 88L163.866 88.5L160.866 93.6962L160 93.1962L163 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 88L171.866 88.5L168.866 93.6962L168 93.1962L171 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 88L179.866 88.5L176.866 93.6962L176 93.1962L179 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 88L187.866 88.5L184.866 93.6962L184 93.1962L187 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 88L195.866 88.5L192.866 93.6962L192 93.1962L195 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 88L203.866 88.5L200.866 93.6962L200 93.1962L203 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 88L211.866 88.5L208.866 93.6962L208 93.1962L211 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 88L219.866 88.5L216.866 93.6962L216 93.1962L219 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 88L227.866 88.5L224.866 93.6962L224 93.1962L227 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 88L235.866 88.5L232.866 93.6962L232 93.1962L235 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 88L243.866 88.5L240.866 93.6962L240 93.1962L243 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 88L251.866 88.5L248.866 93.6962L248 93.1962L251 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 88L259.866 88.5L256.866 93.6962L256 93.1962L259 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 88L267.866 88.5L264.866 93.6962L264 93.1962L267 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 88L275.866 88.5L272.866 93.6962L272 93.1962L275 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 88L283.866 88.5L280.866 93.6962L280 93.1962L283 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 96L-132.134 96.5L-135.134 101.696L-136 101.196L-133 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 96L-124.134 96.5L-127.134 101.696L-128 101.196L-125 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117 96L-116.134 96.5L-119.134 101.696L-120 101.196L-117 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 96L-108.134 96.5L-111.134 101.696L-112 101.196L-109 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101 96L-100.134 96.5L-103.134 101.696L-104 101.196L-101 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93 96L-92.134 96.5L-95.134 101.696L-96 101.196L-93 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 96L-84.134 96.5L-87.134 101.696L-88 101.196L-85 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77 96L-76.134 96.5L-79.134 101.696L-80 101.196L-77 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69 96L-68.134 96.5L-71.134 101.696L-72 101.196L-69 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 96L-60.134 96.5L-63.134 101.696L-64 101.196L-61 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53 96L-52.134 96.5L-55.134 101.696L-56 101.196L-53 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 96L-44.134 96.5L-47.134 101.696L-48 101.196L-45 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37 96L-36.134 96.5L-39.134 101.696L-40 101.196L-37 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 96L-28.134 96.5L-31.134 101.696L-32 101.196L-29 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 96L-20.134 96.5L-23.134 101.696L-24 101.196L-21 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13 96L-12.134 96.5L-15.134 101.696L-16 101.196L-13 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 96L-4.13397 96.5L-7.13397 101.696L-8 101.196L-5 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 96L3.86603 96.5L0.866028 101.696L0 101.196L3 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 96L11.866 96.5L8.86603 101.696L8 101.196L11 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 96L19.866 96.5L16.866 101.696L16 101.196L19 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 96L27.866 96.5L24.866 101.696L24 101.196L27 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 96L35.866 96.5L32.866 101.696L32 101.196L35 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 96L43.866 96.5L40.866 101.696L40 101.196L43 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 96L51.866 96.5L48.866 101.696L48 101.196L51 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 96L59.866 96.5L56.866 101.696L56 101.196L59 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 96L67.866 96.5L64.866 101.696L64 101.196L67 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 96L75.866 96.5L72.866 101.696L72 101.196L75 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 96L83.866 96.5L80.866 101.696L80 101.196L83 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 96L91.866 96.5L88.866 101.696L88 101.196L91 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 96L99.866 96.5L96.866 101.696L96 101.196L99 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 96L107.866 96.5L104.866 101.696L104 101.196L107 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 96L115.866 96.5L112.866 101.696L112 101.196L115 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 96L123.866 96.5L120.866 101.696L120 101.196L123 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 96L131.866 96.5L128.866 101.696L128 101.196L131 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 96L139.866 96.5L136.866 101.696L136 101.196L139 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 96L147.866 96.5L144.866 101.696L144 101.196L147 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 96L155.866 96.5L152.866 101.696L152 101.196L155 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 96L163.866 96.5L160.866 101.696L160 101.196L163 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 96L171.866 96.5L168.866 101.696L168 101.196L171 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 96L179.866 96.5L176.866 101.696L176 101.196L179 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 96L187.866 96.5L184.866 101.696L184 101.196L187 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 96L195.866 96.5L192.866 101.696L192 101.196L195 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 96L203.866 96.5L200.866 101.696L200 101.196L203 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 96L211.866 96.5L208.866 101.696L208 101.196L211 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 96L219.866 96.5L216.866 101.696L216 101.196L219 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 96L227.866 96.5L224.866 101.696L224 101.196L227 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 96L235.866 96.5L232.866 101.696L232 101.196L235 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 96L243.866 96.5L240.866 101.696L240 101.196L243 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 96L251.866 96.5L248.866 101.696L248 101.196L251 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 96L259.866 96.5L256.866 101.696L256 101.196L259 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 96L267.866 96.5L264.866 101.696L264 101.196L267 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 96L275.866 96.5L272.866 101.696L272 101.196L275 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 96L283.866 96.5L280.866 101.696L280 101.196L283 96Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashes);
export default __webpack_public_path__ + "static/media/slashes.2489e818d7dfd220a3d1bb7d610ecc7f.svg";
export { ForwardRef as ReactComponent };